// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:56:55.471Z
// Property: Stonepost Lakeside Apartment Homes (ID: 6767906449167616)
// Collections: 29 amenities, 7 floorplans (live), 43 photos, 72 POIs, 5 reviews, 7 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167616",
  "property_external_id": "1124350",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/stonepost-lakeside-apartment-homes-olathe-ks/2v97b4c/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonepost+Lakeside+Apartment+Homes/@38.8788762,-94.7428886,891m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0bfeed849a103:0x2b3ef9f254555f5a!8m2!3d38.8788762!4d-94.7428886!16s%2Fg%2F1jkw7y1bp?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124350 p1099301",
  "property_status": null,
  "property_slug": "stonepost-lakeside-apartment-homes",
  "property_name": "Stonepost Lakeside Apartment Homes",
  "property_website_url": "https://www.stonepostlakesideapartments.com/",
  "property_domain": "https://www.stonepostlakesideapartments.com/",
  "property_address": "13810 South Pflumm Rd",
  "property_full_address": "13810 South Pflumm Rd, Olathe, KS 66062",
  "property_address_1": "13810 South Pflumm Rd",
  "property_address_2": null,
  "property_address_city": "Olathe",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66062",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Marquiss Lakeside",
  "property_address_latitude": "38.878882",
  "property_address_longitude": "-94.7429227",
  "property_email": "rentcafe.sl@pricekc.com",
  "property_phone": "(913) 423-5362",
  "property_call_tracking_phone": "913-423-5362",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Lakeside calm, Olathe connection.</strong> Stonepost Lakeside Apartment Homes pairs a relaxed waterfront setting with one-, two-, and three-bedroom layouts, in-home washers and dryers, private outdoor space, and easy access to 135th Street and I-35. Schedule your tour and see what home can feel like here.</p>",
  "property_long_description": "<p>Welcome home to Stonepost Lakeside Apartment Homes, where everyday comfort meets a scenic lakeside setting in Olathe, KS. Discover pet-friendly one-, two-, and three-bedroom apartments surrounded by mature landscaping, peaceful pond views, and a nature trail that’s perfect for enjoying a little fresh air. Inside, spacious layouts and thoughtful features make it easy to settle in, while inviting community amenities give you even more ways to enjoy your day. Whether you’re relaxing at home, spending an afternoon by the pool, or exploring nearby shopping and dining, Stonepost Lakeside brings together the comforts you love in a place you’ll love coming home to.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-9a93-77ed-bcf3-f8c065699d8e.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with light wood cabinets, white appliances, and dark countertops.",
    "public_id": "01a0b66b-9a93-77ed-bcf3-f8c065699d8e",
    "storage_key": "property/6767906449167616/01a0b66b-9a93-77ed-bcf3-f8c065699d8e.webp",
    "width": 3000,
    "height": 2000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "284",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.66197183098592",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://stonepostlakesideapartments.securecafeapplicant.com/onlineleasing/content3/access/stonepost-lakeside/floorplans",
  "property_resident_portal_url": "https://stonepostlakesideapartments.securecafe.com/residentservices/stonepost-lakeside/userlogin.aspx",
  "property_apply_now_url": "https://stonepostlakesideapartments.securecafeapplicant.com/onlineleasing/content3/access/stonepost-lakeside/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-a164-733f-b67f-dcebe8a66a9a.webp",
  "property_primary_logo_media": {
    "alt_text": "Stonepost Lakeside Apartment Homes logo",
    "public_id": "01a0b668-a164-733f-b67f-dcebe8a66a9a",
    "storage_key": "property/6767906449167616/01a0b668-a164-733f-b67f-dcebe8a66a9a.webp",
    "width": 731,
    "height": 502
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a140da-0d4d-746c-b891-ca8dfe78c0cb.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stonepost logo",
    "public_id": "01a140da-0d4d-746c-b891-ca8dfe78c0cb",
    "storage_key": "property/6767906449167616/01a140da-0d4d-746c-b891-ca8dfe78c0cb.webp",
    "width": 320,
    "height": 219
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a140d9-abaf-7375-a7f6-eedbca601010.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Stonepost Lakeside Apartment Homes logo",
    "public_id": "01a140d9-abaf-7375-a7f6-eedbca601010",
    "storage_key": "property/6767906449167616/01a140d9-abaf-7375-a7f6-eedbca601010.webp",
    "width": 320,
    "height": 219
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#407EC9",
  "property_secondary_color": "#253746",
  "property_font_color": null,
  "property_color_4": "#C4622D",
  "property_color_3": "#CAB64B",
  "property_color_5": "#A7C6ED",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "633 - 1140",
  "property_sqft_min": "633",
  "property_sqft_max": "1140",
  "property_price_range": "1215 - 4249",
  "property_price_min": "1215",
  "property_price_max": "4249",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/StonepostLakeside",
  "property_instagram_url": "https://www.instagram.com/stonepostlakeside/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJA6FJ2O6_wIcRWl9VVPL5Pis",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stonepost Lakeside Apartment Homes",
  "property_home_romance_title": "Embrace the Joy of Living in Our Charming Community",
  "property_home_amenities_blurb": "<p>Life at Stonepost Lakeside goes beyond your front door. Spend sunny afternoons lounging by the swimming pool, enjoy a cookout at the BBQ and picnic areas, or take a stroll along the nature trail overlooking the pond. Stay active at the 24-hour fitness center, grab a coffee in the clubhouse, or take advantage of the 24-hour business center when it’s time to get things done. With a welcoming mix of outdoor spaces and everyday conveniences, there’s always something to enjoy close to home.</p>",
  "property_home_floorplans_blurb": "<p>Make yourself at home in a space designed for everyday living. Every apartment at Stonepost Lakeside includes a full-size washer and dryer, an all-electric kitchen, 9-foot ceilings, ceiling fans, crown molding, extra storage, and a private patio or balcony. Looking for a few extra touches? Select homes feature stainless steel appliances, kitchen islands, vaulted ceilings, wood-burning fireplaces, garden tubs, and beautiful waterfront views. With Google Fiber internet options available, staying connected is easy, too.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture lakeside living in Olathe.</strong> Browse bright apartment interiors with 9-foot ceilings, crown molding, polished kitchens, and patios or balconies, then zoom out to the lake, fountain, and landscaped courtyards. Preview community spaces made for easy everyday moments, including the pool with lounge seating, clubhouse with coffee bar and billiards, BBQ and picnic areas, fitness center, and pet-friendly green space.</p>",
  "property_home_neighborhood_blurb": "<p>Enjoy the best of Olathe living with shopping, dining, parks, and everyday essentials just minutes from home. Located near West 135th Street and Pflumm Road, Stonepost Lakeside puts you close to Black Bob Marketplace, Santa Fe Square Shopping Center, and Black Bob Park. Convenient access to I-35 also makes it easy to explore Overland Park and the greater Kansas City area. Whether you’re heading out for errands, meeting friends for dinner, or planning your next weekend adventure, you’re never far from where you want to be.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents give Stonepost Lakeside high marks</strong> for cheerful leasing support, prompt maintenance, and well-kept apartment homes in a quiet Olathe setting. Reviews often call out spacious layouts, helpful service, and everyday perks like the dog park, pool, picnic areas, and BBQ spaces—plus a Marquiss Lakeside location near shopping, retail, and I-35. Read the reviews to see what stands out in residents’ own words.</p>",
  "property_neighborhood_blurb": "<p>There’s plenty to love about living in Olathe, KS, and Stonepost Lakeside Apartment Homes puts you close to it all. Located near West 135th Street and Pflumm Road, our community offers convenient access to everyday essentials, local dining, outdoor recreation, and destinations throughout the Kansas City metro.</p><p>Run errands at Black Bob Marketplace, browse nearby shops at Santa Fe Square Shopping Center, or grab a coffee and something sweet at LaMar’s Donuts and Coffee. When you’re ready to get outside, Black Bob Park and the Scheels Overland Park Soccer Complex offer opportunities to enjoy the fresh air, while Deanna Rose Children’s Farmstead makes for a fun local outing.</p><p>With I-35 nearby, getting to Overland Park, Downtown Kansas City, and major area employers is convenient, too. Whether you’re staying close to home or exploring beyond Olathe, Stonepost Lakeside keeps you connected to more of what you enjoy.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Stonepost Lakeside Apartment Homes offers apartments with a pool in Olathe, KS, along with detached garages and carports for flexible parking. Spend the afternoon at the swimming pool and sundeck, walk the nature trail around the pond and fountain, or work out at the 24-hour fitness center.</p><p>The clubhouse has a coffee bar and pool table, and residents also have a 24-hour business center, BBQ and picnic areas, a playground, and an off-leash dog park. Stonepost Lakeside is a smoke-free community with flexible rent payment options.</p><p>Inside, every apartment includes a full-size washer and dryer, an all-electric kitchen, spacious storage, and a private patio or balcony. Select homes add stainless steel appliances, a kitchen island, a wood-burning fireplace, or a pond view.</p>",
  "property_applynow_blurb": "<p><strong>Start your Stonepost Lakeside application online.</strong><br>Choose a one-, two-, or three-bedroom apartment home in a relaxed waterfront setting, with everyday comforts like full-size washer and dryer, 9-foot ceilings, private outdoor space, and Google Fiber access. Apply now and take the next step toward lakeside living in Olathe.</p>",
  "property_contactus_blurb": "<p>Have questions? We’re here to help! Whether you’re exploring <a href=\"/floor-plans\">floor plans</a>, checking apartment availability, asking about our <a href=\"/pet-policy\">pet policy</a>, or getting ready to <a href=\"/schedule-a-tour\">schedule a tour</a>, the Stonepost Lakeside Apartment Homes leasing team would love to hear from you.</p><p>Give us a call, send us a message, or stop by our leasing office in Olathe, KS. We look forward to helping you find a place to call home!</p>",
  "property_faqs_blurb": "<p><strong>Questions about Stonepost Lakeside?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living in our relaxed lakeside setting. If you need details beyond the FAQs, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p>Find your perfect fit at Stonepost Lakeside Apartment Homes. Our one-, two-, and three-bedroom apartments in Olathe, KS offer seven thoughtfully designed floor plans ranging from 633 to 1,276 square feet, giving you plenty of options to make your space your own.</p><p>Enjoy everyday conveniences like a full-size washer and dryer, an all-electric kitchen, 9-foot ceilings, spacious storage, and a private patio or balcony. Select apartments offer even more to love, including stainless steel appliances, kitchen islands, vaulted ceilings, wood-burning fireplaces, garden tubs, and scenic views.</p><p>Whether you’re looking for a cozy one-bedroom retreat or a spacious three-bedroom layout, there’s a place for you at Stonepost Lakeside. Explore our floor plans, compare current pricing and availability, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorites in person.</p>",
  "property_gallery_blurb": "<p>Take a closer look at life at Stonepost Lakeside Apartment Homes. From inviting apartment interiors to scenic outdoor spaces, our photo gallery offers a glimpse of what makes this Olathe community feel like home.</p><p>Picture yourself enjoying coffee on your private patio or balcony, spending a sunny afternoon by the swimming pool, or taking an evening stroll along the pond. Explore our spacious apartment layouts, clubhouse, landscaped grounds, and everyday amenities to see everything waiting for you at Stonepost Lakeside.</p><p>Like what you see? <a href=\"/schedule-a-tour\">Schedule a tour</a> or explore our <a href=\"/virtual-tours\">360° virtual tours</a> to experience more of the community from wherever you are.</p>",
  "property_interactivemap_blurb": "<p>Finding your next apartment just got easier! Explore Stonepost Lakeside Apartment Homes with our interactive property map and discover available apartments in Olathe, KS. Browse the community, compare apartment locations, and find the <a href=\"/floor-plans\">floor plan</a> and features that fit what you’re looking for.</p><p>Filter available homes by bedrooms, bathrooms, square footage, pricing, and move-in date to narrow down your options. Once you’ve found your favorite, review the details, apply online, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person. Your next home could be just a few clicks away!</p>",
  "property_pets_blurb": "<p>Life is even better with your four-legged companions by your side! At Stonepost Lakeside Apartment Homes, we welcome cats and dogs and offer pet-friendly apartments in Olathe, KS, with features that make life with pets more enjoyable.</p><p>Let your pup play at our off-leash dog park, enjoy leashed strolls along the nature trail, or spend time exploring the beautifully landscaped community grounds. With spacious apartment layouts and a welcoming pet-friendly environment, there’s plenty for you and your pets to love about calling Stonepost Lakeside home.</p><p>Have questions about pet fees, breed restrictions, or our <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>? Our leasing team is happy to help you learn more before making your move.</p><h2>Pet Policy Details</h2><ul><li>Dogs and cats are welcome.</li><li>Maximum of 2 pets per apartment home.</li><li>Monthly pet rent: $25 per pet.</li><li>Non-refundable pet fee: $300 for 1 pet or $500 for 2 pets.</li><li>Breed restrictions apply. Contact the leasing office for the full list.</li><li>Exotic, feral, or wild animals are not permitted.</li></ul><h2>Price Brothers Pet Royalty Club</h2><p>Every pet-owning resident at Stonepost Lakeside Apartment Homes is automatically a member of the Price Brothers Pet Royalty Club, included with your pet fee. Members receive a card with special offers and discounts at local pet-related businesses.</p><h2>Assistance Animals</h2><p>Assistance animals are not considered pets and are not subject to pet fees, pet rent, or breed restrictions. Please contact our leasing office to request a reasonable accommodation.</p>",
  "property_referafriend_blurb": "<p><strong>Share the lakeside calm.</strong> Love the fountain pond, nature trail, poolside downtime, and roomy apartment finishes? Invite a friend to discover Stonepost Lakeside Apartment Homes and enjoy the Olathe connection right alongside you.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Stonepost Lakeside.</strong><br>From your relaxed lakeside setting in Marquiss Lakeside, manage the everyday details in just a few clicks. Pay rent, submit maintenance requests, and keep your account current—then get back to enjoying the comfort and calm of home.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> As you browse reviews for Stonepost Lakeside Apartment Homes, you’ll notice recurring praise for the cheerful, responsive leasing team, prompt maintenance, and well-kept apartment homes. Residents mention spacious layouts, quiet surroundings, and helpful service—one review calls the team “always cheerful and helpful.”</p><p>You’ll also see frequent shoutouts for everyday conveniences that make life easier, from the dog park and pool to picnic and BBQ areas. Many reviewers highlight the Marquiss Lakeside location, with shopping, retail, and I-35 access close by. Explore our <a href=\"/amenities\">amenities</a>, view <a href=\"/floor-plans\">floor plans</a>, or read on to see why residents recommend the community in their own words.</p>",
  "property_created_at": "1785792681591",
  "property_scheduletour_blurb": "<p>Ready to experience Stonepost Lakeside Apartment Homes for yourself? We’d love to show you around! Schedule a guided tour of our apartments in Olathe, KS and explore the spacious floor plans, inviting amenities, and beautiful lakeside setting that make our community feel like home.</p><p>Walk through an apartment, take a closer look at the swimming pool and clubhouse, and get answers to your questions from our leasing team. Prefer to explore on your own time? Our interactive <a href=\"/virtual-tours\">360° virtual tours</a> let you discover available layouts from wherever you are.</p><p>Find a time that works for you and take the next step toward your new home at Stonepost Lakeside!</p><h2>Before You Arrive</h2><p>For guided tours, please meet our leasing team at the leasing office about five minutes before your appointment. Please bring a valid photo ID.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> Your inquiry has been received, and the Stonepost Lakeside Apartment Homes leasing team will follow up soon. In the meantime, picture a relaxed waterfront setting with landscaped grounds, a fountain pond, spacious layouts, and everyday Olathe connection just beyond your door.</p>",
  "property_virtualtours_blurb": "<p>Your next home is just a click away! Explore Stonepost Lakeside Apartment Homes with our interactive 360° virtual apartment tours in Olathe, KS. Take a closer look at our one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a>, explore apartment features, and get a feel for the space at your own pace.</p><p>Whether you’re narrowing down your favorites or planning your next move, our virtual tours make it easy to start exploring from wherever you are. When you’re ready to see more, <a href=\"/schedule-a-tour\">schedule an in-person tour</a> and discover the community for yourself.</p>",
  "property_copyright": "2026 All Rights Reserved. Stonepost Lakeside Apartment Homes",
  "property_seo_title_home": "Apartments for Rent in Olathe, KS | Stonepost Lakeside",
  "property_seo_description_home": "Find apartments for rent in Olathe, KS at Stonepost Lakeside Apartment Homes. 1-, 2-, & 3-bedroom homes, a pool, garages, and a lakeside setting.",
  "property_seo_title_floorplans": "1, 2 & 3-Bedroom Olathe Apartments | Stonepost Lakeside",
  "property_seo_description_floorplans": "Explore 1, 2 & 3-bedroom apartments in Olathe, KS at Stonepost Lakeside Apartment Homes, with 633 to 1,276 sq. ft. and a full-size washer & dryer.",
  "property_seo_title_amenities": "Pool & Garage Apartments, Olathe | Stonepost Lakeside",
  "property_seo_description_amenities": "Stonepost Lakeside Apartment Homes offers apartments with a pool in Olathe, KS, plus detached garages, a 24-hour fitness center, and a nature trail.",
  "property_seo_title_gallery": "Luxury Olathe, KS Apartment Photos | Stonepost Lakeside",
  "property_seo_description_gallery": "Tour luxury Olathe, KS apartments in photos. See the kitchens, patios, pool, clubhouse, and lakeside grounds at Stonepost Lakeside Apartment Homes.",
  "property_seo_title_virtualtours": "360° Virtual Tours, Olathe, KS | Stonepost Lakeside",
  "property_seo_description_virtualtours": "Take a 360° virtual tour of every floor plan at Stonepost Lakeside Apartment Homes in Olathe, KS. Explore 1-, 2-, and 3-bedroom homes from anywhere.",
  "property_seo_title_interactivemap": "Pick Your Olathe Apartment Online | Stonepost Lakeside",
  "property_seo_description_interactivemap": "Use the Stonepost Lakeside Apartment Homes interactive map to compare available apartments in Olathe, KS, choose your home, and apply online.",
  "property_seo_title_neighborhood": "Olathe, KS 66062 Neighborhood | Stonepost Lakeside",
  "property_seo_description_neighborhood": "Stonepost Lakeside Apartment Homes puts you near 135th Street, I-35, Black Bob Park, and top Olathe shopping and dining. Explore the neighborhood.",
  "property_seo_title_contact": "Contact Our Olathe Leasing Office | Stonepost Lakeside",
  "property_seo_description_contact": "Connect with Stonepost Lakeside Apartments in Olathe, KS. Explore one, two, or three-bedroom layouts. Contact our leasing team with questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Olathe, KS",
  "property_seo_description_faqs": "Got questions about Stonepost Lakeside in Olathe, KS? Our FAQs cover everything from floor plans to amenities, ensuring your comfort and convenience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Olathe, KS",
  "property_seo_description_reviews": "Join the Stonepost Lakeside community in Olathe, KS, where comfort meets convenience. Check out our residents' reviews and see why they love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Olathe, KS",
  "property_seo_description_applynow": "Experience lakeside living at Stonepost Lakeside in Olathe, KS! Stylish apartments, top amenities, and charming surroundings await. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Stonepost Lakeside Apartment Homes",
  "property_seo_description_residentaccess": "Unlock your Stonepost Lakeside experience! Access the portal to pay rent, request maintenance, and connect with your vibrant Olathe community.",
  "property_seo_title_referafriend": "Refer A Friend | Stonepost Lakeside Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Stonepost Lakeside in Olathe, KS! Great friends create a vibrant community. Share the experience and enjoy life together!",
  "property_seo_title_scheduletour": "Tour Our Olathe, KS Apartments | Stonepost Lakeside",
  "property_seo_description_scheduletour": "Schedule a guided or 360° tour of Stonepost Lakeside Apartment Homes in Olathe, KS. Pick a time that works for you and see your next home.",
  "property_seo_title_privacy": "Privacy Policy | Stonepost Lakeside Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Stonepost Lakeside! Learn how we protect your information while you enjoy the comforts of our Olathe, KS community.",
  "property_seo_title_accessibility": "Website Accessibility | Stonepost Lakeside Apartment Homes",
  "property_seo_description_accessibility": "At Stonepost Lakeside in Olathe, KS, we're committed to digital inclusion. Explore our accessibility features that make life easier for everyone.",
  "property_seo_title_sitemap": "Sitemap | Stonepost Lakeside Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way through Stonepost Lakeside’s offerings! Our sitemap guides you to charming apartments and amenities in beautiful Olathe, KS.",
  "property_seo_title_thankyou": "Thank You | Stonepost Lakeside Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Stonepost Lakeside! Stay tuned as our team will connect soon to help you discover your perfect Olathe home by the lake.",
  "property_seo_title_pets": "Pet-Friendly Apartments, Olathe KS | Stonepost Lakeside",
  "property_seo_description_pets": "Stonepost Lakeside Apartment Homes offers pet-friendly apartments in Olathe, KS with an off-leash dog park. View pet fees, rent, and guidelines.",
  "property_updated_at": "1793743001869",
  "amenities": [
    {
      "id": "ec_8796a14dc877e7946820e6ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126017",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b015-744e-8661-01f0477996b4.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style pool and hot tub with surrounding apartment buildings at sunset.",
        "public_id": "01a0b66b-b015-744e-8661-01f0477996b4",
        "storage_key": "property/6767906449167616/01a0b66b-b015-744e-8661-01f0477996b4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Twilight Pool at Stonepost Lakeside Apartment Homes, Olathe,Drone View Of Pool at Stonepost Lakeside Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71a9ab1f68b6dd74e6599255",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126016",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-ad03-743f-b3a2-4c8b64480d74.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machine, bench press, and free weights.",
        "public_id": "01a0b66b-ad03-743f-b3a2-4c8b64480d74",
        "storage_key": "property/6767906449167616/01a0b66b-ad03-743f-b3a2-4c8b64480d74.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A spacious home gym with a variety of exercise equipment. at Stonepost Lakeside Apartment Homes, Olathe, Kansas,State Of Art Fitness Center at Stonepost Lakeside Apartment Homes, Olathe, 66062,Fitness Studio at Stonepost Lakeside Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fba31d13366b84a1f2c0767a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126014",
      "title": "24-Hour Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-aca1-75ee-bd53-4436897be8c2.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "01a0b66b-aca1-75ee-bd53-4436897be8c2",
        "storage_key": "property/6767906449167616/01a0b66b-aca1-75ee-bd53-4436897be8c2.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Business Center at Stonepost Lakeside Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9951c22d7fc3a68738c4b13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126015",
      "title": "Clubhouse with Pool Table & Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b023-7557-9ff3-60407242bae1.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with comfortable seating and a chandelier.",
        "public_id": "01a0b66b-b023-7557-9ff3-60407242bae1",
        "storage_key": "property/6767906449167616/01a0b66b-b023-7557-9ff3-60407242bae1.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Community Clubhouse at Stonepost Lakeside Apartment Homes, Olathe, 66062,Living Area With TV at Stonepost Lakeside Apartment Homes, Olathe, KS, 66062,Pool Table at Stonepost Lakeside Apartment Homes, Olathe, KS,Clubroom With Fireplace at Stonepost Lakeside Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e343a80f2ebce59dc28459a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126013",
      "title": "BBQ Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b018-76a0-9a9f-841c121fe66b.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio with built-in grill and dining set.",
        "public_id": "01a0b66b-b018-76a0-9a9f-841c121fe66b",
        "storage_key": "property/6767906449167616/01a0b66b-b018-76a0-9a9f-841c121fe66b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Outdoor Patio And Grill at Stonepost Lakeside Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f11fd16ad0fae964e34608f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126019",
      "title": "Detached Garages and Carports Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfb02e760cdf68b8fe6a72e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126025",
      "title": "Off-Leash Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b979-7768-a776-8590e6075150.webp",
      "amenity_image_media": {
        "alt_text": "Spacious green lawn with neatly mowed stripes and trees in the background, featuring a bench and a waste station.",
        "public_id": "01a0b66b-b979-7768-a776-8590e6075150",
        "storage_key": "property/6767906449167616/01a0b66b-b979-7768-a776-8590e6075150.webp",
        "width": 1237,
        "height": 824
      },
      "amenity_image_alt_text": "Lawn at Stonepost Lakeside, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_936c894000f50e77bfca79ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126022",
      "title": "Children's Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-cde7-775e-829d-4ce83731a4a3.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and swings in a grassy area.",
        "public_id": "01a0b66b-cde7-775e-829d-4ce83731a4a3",
        "storage_key": "property/6767906449167616/01a0b66b-cde7-775e-829d-4ce83731a4a3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Play Area at Stonepost Lakeside Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1eaecb248338c9cffeb02e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126020",
      "title": "Nature Trail with Fountain",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-d661-763f-9cba-567366b61c4e.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with a lake and ducks in the foreground.",
        "public_id": "01a0b66b-d661-763f-9cba-567366b61c4e",
        "storage_key": "property/6767906449167616/01a0b66b-d661-763f-9cba-567366b61c4e.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Large Lake View at Stonepost Lakeside Apartment Homes, Olathe, KS,Lake With Fountain at Stonepost Lakeside Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e1cfb22e88fe2f49bca110e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126021",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e2a3efa41f3aedb9f86fdf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126026",
      "title": "Video Library",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d51423ae27a089829dda4aaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "106912866",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5a1ecd8c2af64dda25d5ab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "122755400",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed44d1d3809be2e30db363f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126037",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_081118ce94912d38be7057a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126030",
      "title": "9ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-de48-7103-a61f-9b9c25cdf93a.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a TV, open kitchen, and dining area.",
        "public_id": "01a0b66b-de48-7103-a61f-9b9c25cdf93a",
        "storage_key": "property/6767906449167616/01a0b66b-de48-7103-a61f-9b9c25cdf93a.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Living room with a ceiling fan, crown molding, and tall ceilings. at Stonepost Lakeside Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34cb2f341166ee2760084f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126029",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-c6fa-73a3-923f-01f2f4e30eb3.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a ceiling fan, dresser, and two doors leading to other rooms.",
        "public_id": "01a0b66b-c6fa-73a3-923f-01f2f4e30eb3",
        "storage_key": "property/6767906449167616/01a0b66b-c6fa-73a3-923f-01f2f4e30eb3.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bedroom with a ceiling fan and attached master bathroom. at Stonepost Lakeside Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bea5f8ea7526523b086065e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126038",
      "title": "Cozy Wood Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b148bb6e9f0e2e7bc0fba699",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126031",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-d1d3-703c-a82c-720796109045.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with a table and chairs, sliding glass door, and exterior siding.",
        "public_id": "01a0b66b-d1d3-703c-a82c-720796109045",
        "storage_key": "property/6767906449167616/01a0b66b-d1d3-703c-a82c-720796109045.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Private Patio at Stonepost Lakeside Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7b4c62c863e82650b2cf70a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88147006",
      "title": "Full-Size Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd62bd6755430123c8cef67f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126032",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-f387-7396-b2af-756cc5035e7f.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances including a refrigerator, stove, microwave, and dishwasher.",
        "public_id": "01a0b66b-f387-7396-b2af-756cc5035e7f",
        "storage_key": "property/6767906449167616/01a0b66b-f387-7396-b2af-756cc5035e7f.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Kitchen - Aztec & Hidalgo at Stonepost Lakeside Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f942c942b73218632eca2d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "122011561",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-e09d-716c-91da-272a4f8aaa80.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, stainless steel appliances including a microwave, oven, and refrigerator, and a double sink.",
        "public_id": "01a0b66b-e09d-716c-91da-272a4f8aaa80",
        "storage_key": "property/6767906449167616/01a0b66b-e09d-716c-91da-272a4f8aaa80.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with stainless steel appliances including microwave and dishwasher, and light oak cabinetry with lots of storage. at Stonepost Lakeside Apartment Homes, Olathe, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8f084b7d3566357996d9a2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126035",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-047f-776a-95a7-465daffa14ac.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with island, dining table, and sofa.",
        "public_id": "01a0b66c-047f-776a-95a7-465daffa14ac",
        "storage_key": "property/6767906449167616/01a0b66c-047f-776a-95a7-465daffa14ac.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "An open kitchen and dining area with a kitchen island. at Stonepost Lakeside Apartment Homes, Olathe, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1dbacae28b654795bbce8e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "122011564",
      "title": "Upgraded Dark Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a138061b9d9c007c275fdf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "122011566",
      "title": "Upgraded Lighting*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db58cbbff4edc9f89e4f6534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126033",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-1254-775c-a9db-ac4bdd757d2f.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and a view of the bedroom.",
        "public_id": "01a0b66c-1254-775c-a9db-ac4bdd757d2f",
        "storage_key": "property/6767906449167616/01a0b66c-1254-775c-a9db-ac4bdd757d2f.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Living Room - Aztec & Hidalgo at Stonepost Lakeside Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4364e589a31ee9b7064a4517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126034",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06975572ae4c89c9fc305c1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88126040",
      "title": "Spectacular View of Landscaping*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0be8ed356927427c8647f41c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "88165512",
      "title": "Garden Tub*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-1350-7557-b596-fcd17ced024e.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with tub, shower, toilet, and vanity with sink.",
        "public_id": "01a0b66c-1350-7557-b596-fcd17ced024e",
        "storage_key": "property/6767906449167616/01a0b66c-1350-7557-b596-fcd17ced024e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bathroom - Hidalgo at Stonepost Lakeside Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e562a51649a7018625cbe52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "external_id": "122011563",
      "title": "Handicap Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_984dfa3c287c144ab12eac1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-9a93-77ed-bcf3-f8c065699d8e.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and dark countertops.",
        "public_id": "01a0b66b-9a93-77ed-bcf3-f8c065699d8e",
        "storage_key": "property/6767906449167616/01a0b66b-9a93-77ed-bcf3-f8c065699d8e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring light wood cabinetry, a white refrigerator, oven, and dishwasher, with a dark countertop island and a glimpse into a bedroom.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and dark countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/White Appliances 2.jpg"
    },
    {
      "id": "ec_9b54705ecaad65c7976ca9d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-39db-74ec-9352-d902057d3079.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and dark countertops.",
        "public_id": "01a0b66c-39db-74ec-9352-d902057d3079",
        "storage_key": "property/6767906449167616/01a0b66c-39db-74ec-9352-d902057d3079.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring light wood cabinetry, a white stove and refrigerator, and ample counter space.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and dark countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/White Appliances.jpg"
    },
    {
      "id": "ec_46732d3885c7ce4dcf733e48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-4b33-76e9-bf74-99479f852ecf.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, stainless steel appliances, and a dual sink.",
        "public_id": "01a0b66c-4b33-76e9-bf74-99479f852ecf",
        "storage_key": "property/6767906449167616/01a0b66c-4b33-76e9-bf74-99479f852ecf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring light wood cabinetry, sleek stainless steel appliances including a microwave, oven, and refrigerator, and a convenient dual sink.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, stainless steel appliances, and a dual sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-dsc02502_final.jpg"
    },
    {
      "id": "ec_78e654462f94e9f1dfa43240",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-4aff-7438-b423-56187b90acc0.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with island.",
        "public_id": "01a0b66c-4aff-7438-b423-56187b90acc0",
        "storage_key": "property/6767906449167616/01a0b66c-4aff-7438-b423-56187b90acc0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring an island, perfect for entertaining. Enjoy natural light from the large windows.",
      "link": "false",
      "alt_text": "Open concept living and dining area with island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-dsc02777_final.jpg"
    },
    {
      "id": "ec_fdd586aeb04f4d27856f8666",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-a5b0-70cd-b1f8-64ad4691788e.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen of an apartment.",
        "public_id": "01a0b668-a5b0-70cd-b1f8-64ad4691788e",
        "storage_key": "property/6767906449167616/01a0b668-a5b0-70cd-b1f8-64ad4691788e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious dining area with a round table and chairs, adjacent to a modern kitchen with stainless steel appliances and a large island.",
      "link": "false",
      "alt_text": "Dining area and kitchen of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-dsc02482_final.jpg"
    },
    {
      "id": "ec_92f2d0f578e119d02ef909b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-4b29-71aa-8a0c-266c9e8b7001.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with modern amenities.",
        "public_id": "01a0b66c-4b29-71aa-8a0c-266c9e8b7001",
        "storage_key": "property/6767906449167616/01a0b66c-4b29-71aa-8a0c-266c9e8b7001.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space, perfect for entertaining, featuring a fully equipped kitchen and a comfortable living area.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with modern amenities.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-dsc02527_final.jpg"
    },
    {
      "id": "ec_1aef49d651d673be7d657a25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-a1c4-7788-b3f8-34fecd3aa244.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, white dresser, and a blue armchair visible through an open doorway.",
        "public_id": "01a0b668-a1c4-7788-b3f8-34fecd3aa244",
        "storage_key": "property/6767906449167616/01a0b668-a1c4-7788-b3f8-34fecd3aa244.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable king-sized bed with navy accents, a stylish white dresser, and artwork on the wall. A cozy seating area is visible through the doorway.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, white dresser, and a blue armchair visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-dsc02562_final.jpg"
    },
    {
      "id": "ec_c5a66ede60734baa40619227",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-b80e-72da-bfb9-28d7adcac03d.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, dresser, closet, and en-suite bathroom.",
        "public_id": "01a0b668-b80e-72da-bfb9-28d7adcac03d",
        "storage_key": "property/6767906449167616/01a0b668-b80e-72da-bfb9-28d7adcac03d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a dresser with decorative vases, a walk-in closet with organized clothing, and access to a bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a ceiling fan, dresser, closet, and en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-dsc02647_final.jpg"
    },
    {
      "id": "ec_73aa7a1ec40dab3c2f65956e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-5545-732d-80ec-e16abfb787e6.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, view into bedroom with bed and ceiling fan.",
        "public_id": "01a0b66c-5545-732d-80ec-e16abfb787e6",
        "storage_key": "property/6767906449167616/01a0b66c-5545-732d-80ec-e16abfb787e6.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bathroom vanity with ample storage, leading into a well-lit bedroom with a ceiling fan.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, view into bedroom with bed and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/A3 Main Bath, B3 Guest Bath.jpg"
    },
    {
      "id": "ec_3bd7153abc6195653f2111ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-bade-71bb-a4d0-9d31c2f5cf3f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "01a0b668-bade-71bb-a4d0-9d31c2f5cf3f",
        "storage_key": "property/6767906449167616/01a0b668-bade-71bb-a4d0-9d31c2f5cf3f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with a sink, a toilet, and a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-dsc02612_final.jpg"
    },
    {
      "id": "ec_725cee2d2a530806052f4f43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-bd27-702a-958c-28a4f3e499d0.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothing on hangers.",
        "public_id": "01a0b668-bd27-702a-958c-28a4f3e499d0",
        "storage_key": "property/6767906449167616/01a0b668-bd27-702a-958c-28a4f3e499d0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample hanging space and storage solutions.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothing on hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-dsc02623_final.jpg"
    },
    {
      "id": "ec_80e11e10c6e7ab7a70324f9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b668-badf-72ef-8f26-cd675e56f8e4.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, ironing board, and storage shelves with cleaning supplies.",
        "public_id": "01a0b668-badf-72ef-8f26-cd675e56f8e4",
        "storage_key": "property/6767906449167616/01a0b668-badf-72ef-8f26-cd675e56f8e4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities with ample storage space for all your cleaning needs.",
      "link": "false",
      "alt_text": "Laundry room with washer, dryer, ironing board, and storage shelves with cleaning supplies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-dsc02688_final.jpg"
    },
    {
      "id": "ec_aa1305f50bcd586536efe59e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-6267-76ca-8912-15f7b26f7fd9.webp",
      "image_media": {
        "alt_text": "Balcony with a table and chairs, sliding glass door, and exterior wall.",
        "public_id": "01a0b66c-6267-76ca-8912-15f7b26f7fd9",
        "storage_key": "property/6767906449167616/01a0b66c-6267-76ca-8912-15f7b26f7fd9.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening tea on this charming balcony, complete with a table and chairs.",
      "link": "false",
      "alt_text": "Balcony with a table and chairs, sliding glass door, and exterior wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/A3 B3 Patio(1).jpg"
    },
    {
      "id": "ec_6a3a05ca97e6fa078216a82f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-59e7-764b-80bd-7b91dab391ce.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0b66c-59e7-764b-80bd-7b91dab391ce",
        "storage_key": "property/6767906449167616/01a0b66c-59e7-764b-80bd-7b91dab391ce.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the bubbling hot tub. Perfect for unwinding after a long day or socializing with neighbors.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-13810 South Pflumm Rd-6.jpg"
    },
    {
      "id": "ec_f8952da293d65dbb70133375",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-5a8f-738c-9398-a8de17695716.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana",
        "public_id": "01a0b66c-5a8f-738c-9398-a8de17695716",
        "storage_key": "property/6767906449167616/01a0b66c-5a8f-738c-9398-a8de17695716.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation. ",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-12801 W 136th St-2.jpg"
    },
    {
      "id": "ec_c5c67c010067e1d128fd0e62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-638e-700a-ba90-305df3ab0f6d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and seating areas, surrounded by apartment buildings.",
        "public_id": "01a0b66c-638e-700a-ba90-305df3ab0f6d",
        "storage_key": "property/6767906449167616/01a0b66c-638e-700a-ba90-305df3ab0f6d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Featuring comfortable lounge chairs and ample seating, it's the ideal spot to unwind.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and seating areas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-12801 W 136th St-1.jpg"
    },
    {
      "id": "ec_67d390d1637eeacdd9a4eebf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-642d-7268-9d16-eaa18478cd6a.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with seating and lounge chairs",
        "public_id": "01a0b66c-642d-7268-9d16-eaa18478cd6a",
        "storage_key": "property/6767906449167616/01a0b66c-642d-7268-9d16-eaa18478cd6a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable seating and lounge areas. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Outdoor pool area with seating and lounge chairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-12801 W 136th St-3.jpg"
    },
    {
      "id": "ec_6164a19348b0a2c5ca513861",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-67b1-7554-bc79-0b8ce6f2b5b3.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with a swimming pool and hot tub.",
        "public_id": "01a0b66c-67b1-7554-bc79-0b8ce6f2b5b3",
        "storage_key": "property/6767906449167616/01a0b66c-67b1-7554-bc79-0b8ce6f2b5b3.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor swimming pool and rejuvenating hot tub, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Aerial view of an apartment complex with a swimming pool and hot tub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-12801 W 136th St-23.jpg"
    },
    {
      "id": "ec_d6c3115eb0448212a025cb88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-6ba5-7151-a0aa-390427bfc77f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex swimming pool and surrounding grounds.",
        "public_id": "01a0b66c-6ba5-7151-a0aa-390427bfc77f",
        "storage_key": "property/6767906449167616/01a0b66c-6ba5-7151-a0aa-390427bfc77f.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and beautifully landscaped courtyards. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex swimming pool and surrounding grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-12801 W 136th St-26.jpg"
    },
    {
      "id": "ec_64d9edbfb9e67a7eb5315a38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-d661-763f-9cba-567366b61c4e.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a lake and ducks in the foreground.",
        "public_id": "01a0b66b-d661-763f-9cba-567366b61c4e",
        "storage_key": "property/6767906449167616/01a0b66b-d661-763f-9cba-567366b61c4e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Experience serene living with our beautiful lake, complete with ducks and a soothing fountain. Enjoy the picturesque community views.",
      "link": "false",
      "alt_text": "Apartment buildings with a lake and ducks in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-12801 W 136th St-11(1).jpg"
    },
    {
      "id": "ec_a952307e9e46294072325ae5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-7124-770c-bdb7-cb992499aadb.webp",
      "image_media": {
        "alt_text": "Apartment buildings with fountains in a pond with geese.",
        "public_id": "01a0b66c-7124-770c-bdb7-cb992499aadb",
        "storage_key": "property/6767906449167616/01a0b66c-7124-770c-bdb7-cb992499aadb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Beautiful apartment community with a serene pond and fountains, complete with graceful geese swimming.",
      "link": "false",
      "alt_text": "Apartment buildings with fountains in a pond with geese.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-12801 W 136th St-8.jpg"
    },
    {
      "id": "ec_2123be5ab0342a4ca3de7997",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-91a3-73c8-a3de-1d25f19e809b.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a lake and fountains in front on a sunny day.",
        "public_id": "01a0b66c-91a3-73c8-a3de-1d25f19e809b",
        "storage_key": "property/6767906449167616/01a0b66c-91a3-73c8-a3de-1d25f19e809b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the serene lake and refreshing fountains at our apartment community. Experience tranquil living with beautiful outdoor spaces.",
      "link": "false",
      "alt_text": "Apartment buildings with a lake and fountains in front on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-12801 W 136th St-12(1).jpg"
    },
    {
      "id": "ec_0ef94be518df8bc0310bc0d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-777f-75f2-bda5-7a847f72fdb9.webp",
      "image_media": {
        "alt_text": "Covered picnic areas with tables overlook a serene lake and apartment buildings.",
        "public_id": "01a0b66c-777f-75f2-bda5-7a847f72fdb9",
        "storage_key": "property/6767906449167616/01a0b66c-777f-75f2-bda5-7a847f72fdb9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our covered picnic areas, perfect for a relaxing afternoon by the lake. Ample seating and scenic views make this community amenity a favorite.",
      "link": "false",
      "alt_text": "Covered picnic areas with tables overlook a serene lake and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-12801 W 136th St-9.jpg"
    },
    {
      "id": "ec_b80e83e797a993657497ebe7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-937f-728a-8f2b-0a75a4f46141.webp",
      "image_media": {
        "alt_text": "Picnic area with a wooden pergola overlooking a lake with apartment buildings in the background.",
        "public_id": "01a0b66c-937f-728a-8f2b-0a75a4f46141",
        "storage_key": "property/6767906449167616/01a0b66c-937f-728a-8f2b-0a75a4f46141.webp",
        "width": 1371,
        "height": 913
      },
      "title": "Community",
      "description": "Enjoy a relaxing picnic by the lake in our beautiful community, surrounded by lush green spaces and apartment homes.",
      "link": "false",
      "alt_text": "Picnic area with a wooden pergola overlooking a lake with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5SPL-Amenities-26.jpg"
    },
    {
      "id": "ec_44f0d28faf4880da362edde7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-cde7-775e-829d-4ce83731a4a3.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings in a grassy area.",
        "public_id": "01a0b66b-cde7-775e-829d-4ce83731a4a3",
        "storage_key": "property/6767906449167616/01a0b66b-cde7-775e-829d-4ce83731a4a3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for children to play and explore. Features safe, modern equipment for endless entertainment.",
      "link": "false",
      "alt_text": "Playground with slides and swings in a grassy area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-12801 W 136th St-10.jpg"
    },
    {
      "id": "ec_853ddd513ca2db0fae6ab0cf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-99d2-712a-831c-7b8057fb8045.webp",
      "image_media": {
        "alt_text": "Courtyard with a fountain and seating areas surrounded by apartment buildings.",
        "public_id": "01a0b66c-99d2-712a-831c-7b8057fb8045",
        "storage_key": "property/6767906449167616/01a0b66c-99d2-712a-831c-7b8057fb8045.webp",
        "width": 1322,
        "height": 881
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped courtyard featuring a central fountain, comfortable seating areas, and lush green lawns, all surrounded by our elegant apartment buildings.",
      "link": "false",
      "alt_text": "Courtyard with a fountain and seating areas surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5SPL-Amenities-14.jpg"
    },
    {
      "id": "ec_cc3af5a3194fc8191fc24c44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-a1e0-7599-ab5c-99fec12700ce.webp",
      "image_media": {
        "alt_text": "Exterior entrance of a building with stone and stucco facade, large wooden doors, and decorative plants.",
        "public_id": "01a0b66c-a1e0-7599-ab5c-99fec12700ce",
        "storage_key": "property/6767906449167616/01a0b66c-a1e0-7599-ab5c-99fec12700ce.webp",
        "width": 1191,
        "height": 794
      },
      "title": "Community",
      "description": "Welcome to our community's main entrance. This building facade features a blend of stone and stucco, with grand wooden doors and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior entrance of a building with stone and stucco facade, large wooden doors, and decorative plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/5SPL-Amenities-22.jpg"
    },
    {
      "id": "ec_7ec1b07eaf8a020227608808",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-93d0-77eb-a843-915173a3c5c5.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and grass in the foreground.",
        "public_id": "01a0b66c-93d0-77eb-a843-915173a3c5c5",
        "storage_key": "property/6767906449167616/01a0b66c-93d0-77eb-a843-915173a3c5c5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of the apartment complex, showcasing spacious balconies and lush green lawns.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and grass in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Building Exterior(2).jpg"
    },
    {
      "id": "ec_f4eb32c63ab0244b3b5794f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-9d14-771b-a21f-61e36d58d92a.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily building with stone accents and balconies.",
        "public_id": "01a0b66c-9d14-771b-a21f-61e36d58d92a",
        "storage_key": "property/6767906449167616/01a0b66c-9d14-771b-a21f-61e36d58d92a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround this stunning multifamily property, featuring elegant architecture with stone accents and private balconies.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily building with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Building Exterior 2.jpg"
    },
    {
      "id": "ec_f9d134ad61ac1279672a50d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b018-76a0-9a9f-841c121fe66b.webp",
      "image_media": {
        "alt_text": "Outdoor patio with built-in grill and dining set.",
        "public_id": "01a0b66b-b018-76a0-9a9f-841c121fe66b",
        "storage_key": "property/6767906449167616/01a0b66b-b018-76a0-9a9f-841c121fe66b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining on this spacious patio, complete with a built-in grill and comfortable seating.",
      "link": "false",
      "alt_text": "Outdoor patio with built-in grill and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-12801 W 136th St-7.jpg"
    },
    {
      "id": "ec_7a0dade3352e980e004b886a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-9fc5-744b-8e28-d66ae4654c0e.webp",
      "image_media": {
        "alt_text": "Community kitchen with island and seating area",
        "public_id": "01a0b66c-9fc5-744b-8e28-d66ae4654c0e",
        "storage_key": "property/6767906449167616/01a0b66c-9fc5-744b-8e28-d66ae4654c0e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A spacious community kitchen area featuring a large island with bar stools and high-top tables with chairs, perfect for social gatherings.",
      "link": "false",
      "alt_text": "Community kitchen with island and seating area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-12801 W 136th St-19.jpg"
    },
    {
      "id": "ec_66c7cc9c20b30bc4b4d401b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-b023-7557-9ff3-60407242bae1.webp",
      "image_media": {
        "alt_text": "Community lounge with comfortable seating and a chandelier.",
        "public_id": "01a0b66b-b023-7557-9ff3-60407242bae1",
        "storage_key": "property/6767906449167616/01a0b66b-b023-7557-9ff3-60407242bae1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring plush seating and elegant lighting.",
      "link": "false",
      "alt_text": "Community lounge with comfortable seating and a chandelier.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-12801 W 136th St-16.jpg"
    },
    {
      "id": "ec_4b352cc8372963c473f8bfa9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-a274-712b-a852-c4f1a8fe419d.webp",
      "image_media": {
        "alt_text": "Kitchen and billiards room in apartment complex.",
        "public_id": "01a0b66c-a274-712b-a852-c4f1a8fe419d",
        "storage_key": "property/6767906449167616/01a0b66c-a274-712b-a852-c4f1a8fe419d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our spacious kitchen and billiards room, perfect for entertaining guests or relaxing with friends.",
      "link": "false",
      "alt_text": "Kitchen and billiards room in apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-12801 W 136th St-18.jpg"
    },
    {
      "id": "ec_43b2be10cc9279fa53938860",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-a640-73cd-acbe-e9c7bf89d6e9.webp",
      "image_media": {
        "alt_text": "Reception desk with seating area in a multifamily property lobby.",
        "public_id": "01a0b66c-a640-73cd-acbe-e9c7bf89d6e9",
        "storage_key": "property/6767906449167616/01a0b66c-a640-73cd-acbe-e9c7bf89d6e9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome guests and residents at the sophisticated reception area, featuring comfortable seating and a professional desk.",
      "link": "false",
      "alt_text": "Reception desk with seating area in a multifamily property lobby.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-12801 W 136th St-13.jpg"
    },
    {
      "id": "ec_0ee315d9c02828022d623505",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-c075-73ce-bf06-9a849ab7bfda.webp",
      "image_media": {
        "alt_text": "Community dining room with a large wooden table and chairs, chandelier, and window overlooking an outdoor area.",
        "public_id": "01a0b66c-c075-73ce-bf06-9a849ab7bfda",
        "storage_key": "property/6767906449167616/01a0b66c-c075-73ce-bf06-9a849ab7bfda.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy communal dining in our stylish community room, perfect for gatherings and events. Features a large table, comfortable seating, and elegant lighting.",
      "link": "false",
      "alt_text": "Community dining room with a large wooden table and chairs, chandelier, and window overlooking an outdoor area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-12801 W 136th St-21.jpg"
    },
    {
      "id": "ec_929c0ee9a0833cf9d70d2b25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-c094-7322-96ae-4feb3ea7e7a8.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with leather chairs and a built-in entertainment center.",
        "public_id": "01a0b66c-c094-7322-96ae-4feb3ea7e7a8",
        "storage_key": "property/6767906449167616/01a0b66c-c094-7322-96ae-4feb3ea7e7a8.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lounge area, featuring plush seating and a large entertainment center.",
      "link": "false",
      "alt_text": "Comfortable seating area with leather chairs and a built-in entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-12801 W 136th St-17.jpg"
    },
    {
      "id": "ec_8f0383d535ba3d54fc49a811",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-adf3-75ad-a8a1-0f4beb04eabe.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, two sofas, armchairs, and chandelier",
        "public_id": "01a0b66c-adf3-75ad-a8a1-0f4beb04eabe",
        "storage_key": "property/6767906449167616/01a0b66c-adf3-75ad-a8a1-0f4beb04eabe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large stone fireplace, comfortable seating with sofas and armchairs, and an elegant chandelier.",
      "link": "false",
      "alt_text": "Living room with fireplace, two sofas, armchairs, and chandelier",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-12801 W 136th St-14(1).jpg"
    },
    {
      "id": "ec_8bbe01de98251925437d9b99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-afc8-740f-acee-bfdb4b6c07d0.webp",
      "image_media": {
        "alt_text": "Community room with a pool table, seating, and a kitchenette.",
        "public_id": "01a0b66c-afc8-740f-acee-bfdb4b6c07d0",
        "storage_key": "property/6767906449167616/01a0b66c-afc8-740f-acee-bfdb4b6c07d0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy friendly competition in our community's recreation room, complete with a billiards table and a convenient kitchenette for snacks and drinks.",
      "link": "false",
      "alt_text": "Community room with a pool table, seating, and a kitchenette.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-12801 W 136th St-20.jpg"
    },
    {
      "id": "ec_06a6fb2a3e24338acb0e1e49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-afeb-740b-8898-953578c94bfe.webp",
      "image_media": {
        "alt_text": "Coffee station with snacks and a painting in a multifamily property common area.",
        "public_id": "01a0b66c-afeb-740b-8898-953578c94bfe",
        "storage_key": "property/6767906449167616/01a0b66c-afeb-740b-8898-953578c94bfe.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at the coffee station in our community common area, perfect for a quick pick-me-up.",
      "link": "false",
      "alt_text": "Coffee station with snacks and a painting in a multifamily property common area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-12801 W 136th St-15.jpg"
    },
    {
      "id": "ec_b847fcb2c1e2d15f057a29f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-aca1-75ee-bd53-4436897be8c2.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "01a0b66b-aca1-75ee-bd53-4436897be8c2",
        "storage_key": "property/6767906449167616/01a0b66b-aca1-75ee-bd53-4436897be8c2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, equipped with computers and printers for your convenience.",
      "link": "false",
      "alt_text": "Business center with computers and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-12801 W 136th St-22.jpg"
    },
    {
      "id": "ec_cae8b6c9d935f81c77a2c466",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66b-ad03-743f-b3a2-4c8b64480d74.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machine, bench press, and free weights.",
        "public_id": "01a0b66b-ad03-743f-b3a2-4c8b64480d74",
        "storage_key": "property/6767906449167616/01a0b66b-ad03-743f-b3a2-4c8b64480d74.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, a weight machine, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Gym with treadmills, elliptical, weight machine, bench press, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-12801 W 136th St-6.jpg"
    },
    {
      "id": "ec_d5f496e1a4cac12245c1eac6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-cfe2-76ca-95b4-c0260f166537.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and free weights.",
        "public_id": "01a0b66c-cfe2-76ca-95b4-c0260f166537",
        "storage_key": "property/6767906449167616/01a0b66c-cfe2-76ca-95b4-c0260f166537.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, and a free weight area for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-12801 W 136th St-5.jpg"
    },
    {
      "id": "ec_cffe3b7f3935c75b9e69b7d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66c-d023-7180-9668-cecd8f941659.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and free weights.",
        "public_id": "01a0b66c-d023-7180-9668-cecd8f941659",
        "storage_key": "property/6767906449167616/01a0b66c-d023-7180-9668-cecd8f941659.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with modern cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with weight machines and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-12801 W 136th St-4.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f88d61c3-b7b0-44b1-9be9-83ffae7794eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Pizza Shoppe",
      "poi_type": "Restaurants",
      "poi_address": "12750 South Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Casual regional chain known for its creative pizzas with cracker crusts, plus sandwiches & pastas.",
      "poi_long_description": "Casual regional chain known for its creative pizzas with cracker crusts, plus sandwiches & pastas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98f-355a-769d-8ff1-a91648c53c40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-355a-769d-8ff1-a91648c53c40",
        "storage_key": "property/6767906449167616/019fc98f-355a-769d-8ff1-a91648c53c40.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pizzashoppepflumm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16702389570820783627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-shoppe",
      "poi_latitude": "38.897441",
      "poi_longitude": "-94.743489",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-397-7117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4WBCFyVwIcRCz72VNLOyuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f57757a9-38ad-442a-9692-c98451790262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "14075 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98e-37cd-75e3-a94b-c2832c053119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-37cd-75e3-a94b-c2832c053119",
        "storage_key": "property/6767906449167616/019fc98e-37cd-75e3-a94b-c2832c053119.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/ks/olathe/14075-w-135th-st?y_source=1_NjY1MDIyMjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12804043831846698807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "38.8831047",
      "poi_longitude": "-94.7490918",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac0a-772b-b98b-b410ccf076d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac0a-772b-b98b-b410ccf076d4",
        "storage_key": "property/6767906449167616/019ff6a8-ac0a-772b-b98b-b410ccf076d4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJx_34_xG_wIcRN__AvQYasbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9934f154-6b08-41eb-80c9-a5678359d656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "14123 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-6632-7224-9c4c-884db6fc2d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-6632-7224-9c4c-884db6fc2d02",
        "storage_key": "property/6767906449167616/019ff6a8-6632-7224-9c4c-884db6fc2d02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/ks/olathe/14123-w-135th-street.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11577046203214370136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "38.8830888",
      "poi_longitude": "-94.7495069",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-324-5451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRTAo9C_wIcRWJXgGi_uqaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_088e0b6e-9052-48a9-b33b-52f7f0dc36a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "14317 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-605f-751d-a018-b34df61d9f2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-605f-751d-a018-b34df61d9f2f",
        "storage_key": "property/6767906449167616/019ff6a8-605f-751d-a018-b34df61d9f2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/ks/olathe/14317-w-135th-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=3164",
      "poi_directions_map_url": "https://maps.google.com/?cid=6598985433394558996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "38.8830617",
      "poi_longitude": "-94.752115",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-782-0691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFy038xy_wIcRFLh160lOlFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3b111cf1-dbc2-46c8-aaa7-009ceebc2df9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Andy's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "13981 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-40ca-715a-a966-7fa124aabc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-40ca-715a-a966-7fa124aabc39",
        "storage_key": "property/6767906449167616/01a0b66a-40ca-715a-a966-7fa124aabc39.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/Kansas/Olathe/13981-W-135th-St",
      "poi_directions_map_url": "https://maps.google.com/?cid=524064902263753023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-frozen-custard",
      "poi_latitude": "38.8830773",
      "poi_longitude": "-94.7480742",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-286-4240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzZ5qL3i_wIcRP0mugkDaRQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_2c6b8b2f-198c-4c82-bbf5-386d674f53c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "The Other Place Olathe",
      "poi_type": "Restaurants",
      "poi_address": "16590 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, salads & beer.",
      "poi_long_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, salads & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-6237-720b-9e72-a0a043388d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-6237-720b-9e72-a0a043388d10",
        "storage_key": "property/6767906449167616/019ff6a8-6237-720b-9e72-a0a043388d10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theotherplace.com/location/olathe-kansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=13772686995452198420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-other-place-olathe",
      "poi_latitude": "38.88475409999999",
      "poi_longitude": "-94.775983",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-791-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQ39zC6-wIcRFP6R_tlpIr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d15bc5a6-145b-4882-be40-ead0aece824e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Bonito Michoacán",
      "poi_type": "Restaurants",
      "poi_address": "1231 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Butcher shop, bakery and store selling Mexican meat cuts, plus tacos and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98e-2b37-7289-9d8a-503f428a532e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-2b37-7289-9d8a-503f428a532e",
        "storage_key": "property/6767906449167616/019fc98e-2b37-7289-9d8a-503f428a532e.webp",
        "width": 639,
        "height": 640
      },
      "poi_business_url": "http://bonitomichoacán.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800372171173904509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonito-michoacn",
      "poi_latitude": "38.8827407",
      "poi_longitude": "-94.7976309",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-768-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcX2Chu-wIcRfcDJlcYyRts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_4500bdd3-9127-4c44-ac8a-c5fa753151ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Sweet Tee's Coffee Shop",
      "poi_type": "Restaurants",
      "poi_address": "2063 E Santa Fe St, Olathe, KS 66062, USA",
      "poi_short_description": "Two-location shop serving coffee, hot and iced tea and pastries in relaxing surroundings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6d1-8341-723f-aaa9-42d790f07ebc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d1-8341-723f-aaa9-42d790f07ebc",
        "storage_key": "property/6767906449167616/019ff6d1-8341-723f-aaa9-42d790f07ebc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sweetteescoffeeshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1926364422690450855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-tees-coffee-shop",
      "poi_latitude": "38.881949",
      "poi_longitude": "-94.782262",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-544-9705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac0a-772b-b98b-b410ccf076d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac0a-772b-b98b-b410ccf076d4",
        "storage_key": "property/6767906449167616/019ff6a8-ac0a-772b-b98b-b410ccf076d4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtUFf_iS-wIcRpy1qcjzSuxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_4e57bbfd-776c-41da-9565-4df41779294d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Austins Bar & Grill | South Olathe",
      "poi_type": "Restaurants",
      "poi_address": "2103 E 151st St #2969, Olathe, KS 66062, USA",
      "poi_short_description": "Burgers & an elevated pub-food menu plus lots of TVs for sports-watching from any table.",
      "poi_long_description": "Burgers & an elevated pub-food menu plus lots of TVs for sports-watching from any table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6d1-84b2-70a2-8114-1e478916abde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d1-84b2-70a2-8114-1e478916abde",
        "storage_key": "property/6767906449167616/019ff6d1-84b2-70a2-8114-1e478916abde.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://austinsbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=624285126878378824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austins-bar--grill--south-olathe",
      "poi_latitude": "38.8541101",
      "poi_longitude": "-94.7813857",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-829-2106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu2QHIlq-wIcRSDsl6gPoqQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_69119203-575d-47a8-9d33-40d1c842b36c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Hy-Vee Market Grille",
      "poi_type": "Restaurants",
      "poi_address": "14955 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Casual spot with a varied American menu, a full bar with a large craft beer list & Sunday brunch.",
      "poi_long_description": "Casual spot with a varied American menu, a full bar with a large craft beer list & Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-41ca-77d0-93c0-dffa8ca9fdce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-41ca-77d0-93c0-dffa8ca9fdce",
        "storage_key": "property/6767906449167616/01a0b66a-41ca-77d0-93c0-dffa8ca9fdce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hy-vee.com/pages/mealtime?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4395779024800701400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-market-grille",
      "poi_latitude": "38.8526314",
      "poi_longitude": "-94.7586927",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-254-4755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVwyUq-_wIcR2NtbtLvxAD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9ef83749-6fd1-4d60-a4bd-a62a684eec2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "12101 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-412a-716a-9d8e-48d8996424fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-412a-716a-9d8e-48d8996424fe",
        "storage_key": "property/6767906449167616/01a0b66a-412a-716a-9d8e-48d8996424fe.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/locations/states/ks/olathe/243",
      "poi_directions_map_url": "https://maps.google.com/?cid=16847049468812736311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "38.909173",
      "poi_longitude": "-94.7733774",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-780-9108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwG7PZ-VwIcRNzcEfju-zOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3905d264-7492-4015-bf0d-a5b68ba19075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Tall Trellis Brew Co.",
      "poi_type": "Restaurants",
      "poi_address": "25600 W Valley Pkwy, Olathe, KS 66061, USA",
      "poi_short_description": "Brewpub featuring outdoor seating for casual eats and housemade and local brews.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-4774-7306-a221-280198138557.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-4774-7306-a221-280198138557",
        "storage_key": "property/6767906449167616/01a0b66a-4774-7306-a221-280198138557.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talltrellis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9598319035616604153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tall-trellis-brew-co",
      "poi_latitude": "38.9450675",
      "poi_longitude": "-94.8846037",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QZJJ3iXwIcR-S_MDk8UNIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_d8519017-98b1-48aa-a5a1-35c06f894e46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Red Door Woodfired Grill",
      "poi_type": "Restaurants",
      "poi_address": "11851 Roe Ave, Leawood, KS 66211, USA",
      "poi_short_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_long_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-4774-7306-a221-2c9be152c80c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-4774-7306-a221-2c9be152c80c",
        "storage_key": "property/6767906449167616/01a0b66a-4774-7306-a221-2c9be152c80c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://reddoorgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18358751246709491710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-door-woodfired-grill",
      "poi_latitude": "38.9139376",
      "poi_longitude": "-94.6376498",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-227-4959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV6WDqfPpwIcR_gfhc_1ix_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_da691f18-9d70-412f-bc25-1a91ba016b41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "13600 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Grocer, bakery and deli selling fresh produce, seafood and meat.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-6fe8-721b-a932-cec6cdf3e13f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-6fe8-721b-a932-cec6cdf3e13f",
        "storage_key": "property/6767906449167616/019ff6a8-6fe8-721b-a932-cec6cdf3e13f.webp",
        "width": 1280,
        "height": 840
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11849175053530700432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.8819321",
      "poi_longitude": "-94.7643931",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-782-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b5c1-765c-8a5d-fd3203c6b213.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b5c1-765c-8a5d-fd3203c6b213",
        "storage_key": "property/6767906449167616/019fc98b-b5c1-765c-8a5d-fd3203c6b213.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo5n_JtK_wIcRkBoee-65cKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dcfe66fc-1f3d-4a58-9191-20fde7d43eb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "13600 S Alden St, Olathe, KS 66062, USA",
      "poi_short_description": "Grocery and home goods retailer selling household essentials, plus toys, clothing, electronics and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-6c62-7012-963f-ef8165b69e44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-6c62-7012-963f-ef8165b69e44",
        "storage_key": "property/6767906449167616/019ff6a8-6c62-7012-963f-ef8165b69e44.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/577-olathe-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8847812053339146437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8813311",
      "poi_longitude": "-94.7580085",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-829-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKfgVptq_wIcRxQizTi--yXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_75ef58e9-4561-42ea-89da-ce0ea3f85b70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "13450 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98f-af4a-70dd-a494-6c9ccad578fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-af4a-70dd-a494-6c9ccad578fe",
        "storage_key": "property/6767906449167616/019fc98f-af4a-70dd-a494-6c9ccad578fe.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13450+s+blackbob+rd-olathe-ks-66062/id=4665",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796038198735279990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8843227",
      "poi_longitude": "-94.7616559",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-829-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3StTdC_wIcRdhfmTHQ6-PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5f5b675c-4758-40e7-a6fa-df98a4d30137",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "15650 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98f-a4d2-750a-9567-6458826d9024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-a4d2-750a-9567-6458826d9024",
        "storage_key": "property/6767906449167616/019fc98f-a4d2-750a-9567-6458826d9024.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/olathe/15650-w-135th-st?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ0NDctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7286540124918162984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.8844211",
      "poi_longitude": "-94.7664832",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-390-0068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac11-77a6-8021-2d3cf7358523.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac11-77a6-8021-2d3cf7358523",
        "storage_key": "property/6767906449167616/019ff6a8-ac11-77a6-8021-2d3cf7358523.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJYW3WntO_wIcRKKZgS6P9HmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_0dc54736-b30b-41d5-a46b-4c5ac438340a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "14011 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc991-0886-7098-9624-030d0ddaa10f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-0886-7098-9624-030d0ddaa10f",
        "storage_key": "property/6767906449167616/019fc991-0886-7098-9624-030d0ddaa10f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3343&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4463119196626745940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menards",
      "poi_latitude": "38.8816338",
      "poi_longitude": "-94.7489319",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-777-0147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu7YYgOe_wIcRVPopQUMv8D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fab1edee-8ab6-47c3-bb79-cda3c796c5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "16250 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc990-e952-71ce-8ced-a9cc7341b3f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-e952-71ce-8ced-a9cc7341b3f1",
        "storage_key": "property/6767906449167616/019fc990-e952-71ce-8ced-a9cc7341b3f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/ks/olathe-231.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9822339370780813415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "38.8850267",
      "poi_longitude": "-94.77371180000002",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ38j_Biy-wIcRZ2i54p31T4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_de66fcb7-56ac-4a93-82a6-c110e1abfeb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "15345 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6d1-9132-74da-851c-b6afa200b2bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d1-9132-74da-851c-b6afa200b2bd",
        "storage_key": "property/6767906449167616/019ff6d1-9132-74da-851c-b6afa200b2bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/olathe/1756",
      "poi_directions_map_url": "https://maps.google.com/?cid=15254225791980064040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9099463",
      "poi_longitude": "-94.7643047",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-393-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz82Qo3SVwIcRKM2SlonlsdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0a5f4f4b-5f70-4848-95be-4f558c1f8c4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Marshalls & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "14645 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6d1-8eef-70f8-a3a1-43857ac1c6e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d1-8eef-70f8-a3a1-43857ac1c6e2",
        "storage_key": "property/6767906449167616/019ff6d1-8eef-70f8-a3a1-43857ac1c6e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12789461001943422484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls--homegoods",
      "poi_latitude": "38.90993160000001",
      "poi_longitude": "-94.7569748",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-764-6336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV1yLRxOVwIcRFJaMEQVLfbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_010d15a5-9df0-4b7d-be8d-a7297b8cf552",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "11750 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-4e51-774b-a83b-24631c39a220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-4e51-774b-a83b-24631c39a220",
        "storage_key": "property/6767906449167616/01a0b66a-4e51-774b-a83b-24631c39a220.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ks/olathe/11750-s-strang-line-rd-193.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=9427464391758282967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "38.915041",
      "poi_longitude": "-94.766844",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-829-0492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOYUNsQuVwIcR14BlW-oU1YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_22ff36e2-2443-4bba-a400-dff65f1588b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Walnut Grove Elementary School",
      "poi_type": "Education",
      "poi_address": "11800 South Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.olatheschools.org/walnutgrove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11890214342694769779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-grove-elementary-school",
      "poi_latitude": "38.9147622",
      "poi_longitude": "-94.7450276",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-7710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZSXY_T6VwIcRc5STl_KGAqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fd2a2dce-00b9-4ed1-afc8-0f6c4695d310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Regency Place Elementary School",
      "poi_type": "Education",
      "poi_address": "13250 S Greenwood St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-74ae-7301-a923-191f578c125a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-74ae-7301-a923-191f578c125a",
        "storage_key": "property/6767906449167616/019ff6a8-74ae-7301-a923-191f578c125a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheschools.org/regencyplace/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12860185387975329175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-place-elementary-school",
      "poi_latitude": "38.8881055",
      "poi_longitude": "-94.7510144",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfQT9U96_wIcRl0XwY3mOeLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5aeb3e94-b8aa-4e00-a5d8-a88b4c728b20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Ravenwood Elementary School",
      "poi_type": "Education",
      "poi_address": "12211 S Clinton St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-4e44-701a-bf0a-ebb32d8c8cd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-4e44-701a-bf0a-ebb32d8c8cd1",
        "storage_key": "property/6767906449167616/01a0b66a-4e44-701a-bf0a-ebb32d8c8cd1.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.olatheschools.org/ravenwood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3126603313647680743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ravenwood-elementary-school",
      "poi_latitude": "38.906644",
      "poi_longitude": "-94.8262665",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-780-7640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDTGPgRSWwIcR53yH9yXtYys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aa0307b7-a2b7-4cd3-aaff-e6f13fde716f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Mahaffie Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 N Nelson Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-4e40-706c-86b8-1184bd1381de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-4e40-706c-86b8-1184bd1381de",
        "storage_key": "property/6767906449167616/01a0b66a-4e40-706c-86b8-1184bd1381de.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "http://www.olatheschools.org/mahaffie/",
      "poi_directions_map_url": "https://maps.google.com/?cid=397412615802508045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-elementary-school",
      "poi_latitude": "38.9033177",
      "poi_longitude": "-94.805968",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-780-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3paiOOVwIcRDdMqIqvkgwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2332ca45-433c-43e5-8dd2-e795700a28f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Pioneer Trail Middle School",
      "poi_type": "Education",
      "poi_address": "15100 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/pioneertrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2058636432383380672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-trail-middle-school",
      "poi_latitude": "38.8992082",
      "poi_longitude": "-94.7643025",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-7270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6fYTI3qVwIcRwIzjme2-kRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5e2a0c83-9d63-41cb-bfbc-0e6396e36430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Olathe South High School",
      "poi_type": "Education",
      "poi_address": "1640 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-7c70-730e-b038-6975cec3e07a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-7c70-730e-b038-6975cec3e07a",
        "storage_key": "property/6767906449167616/019ff6a8-7c70-730e-b038-6975cec3e07a.webp",
        "width": 1280,
        "height": 859
      },
      "poi_business_url": "https://www.olatheschools.org/south/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17649884845403837348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-south-high-school",
      "poi_latitude": "38.8559977",
      "poi_longitude": "-94.7923901",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-780-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5xdptWe-wIcRpJPY-MD88PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_687c91d3-2bb3-4f10-8ce3-ead52912229d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Community College: Olathe Health Education Center",
      "poi_type": "Education",
      "poi_address": "21201 W 152nd St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-8243-746b-b162-30bbad0f6602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8243-746b-b162-30bbad0f6602",
        "storage_key": "property/6767906449167616/019ff6a8-8243-746b-b162-30bbad0f6602.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "https://www.jccc.edu/about/campus/maps/off-campus/ohec.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2051377352076894764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college-olathe-health-education-center",
      "poi_latitude": "38.85235",
      "poi_longitude": "-94.83084",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-469-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXeUftMm9wIcRLCLTQtX0dxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_e409bca0-ee0c-4c13-aff3-5d443d128cfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-6c5f-722c-bb89-d07acef2328d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6c5f-722c-bb89-d07acef2328d",
        "storage_key": "property/6767906449167616/019fc98a-6c5f-722c-bb89-d07acef2328d.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4b716ca0-be27-4791-843e-ed574d0e93b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Kiddie Academy of Olathe",
      "poi_type": "Education",
      "poi_address": "1585 S Mahaffie Cir, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-51c9-7721-ac1a-31b98a638865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-51c9-7721-ac1a-31b98a638865",
        "storage_key": "property/6767906449167616/01a0b66a-51c9-7721-ac1a-31b98a638865.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/olathe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=440037305803804362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-olathe",
      "poi_latitude": "38.8563946",
      "poi_longitude": "-94.8061023",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-732-7773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbUt8uZ6_wIcRyg5bJJlTGwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_de6619e5-967d-4311-8208-9a4fb30ebfe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Children of America North Olathe",
      "poi_type": "Education",
      "poi_address": "11134 S Noble Dr, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0100f-5b2e-73fb-bea9-a1e25d36e2a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-5b2e-73fb-bea9-a1e25d36e2a6",
        "storage_key": "property/6767906449167616/01a0100f-5b2e-73fb-bea9-a1e25d36e2a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.childrenofamerica.com/locations-northolathe.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=14220908372325428040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "children-of-america-north-olathe",
      "poi_latitude": "38.926195",
      "poi_longitude": "-94.8380745",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-453-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCZQMWOiXwIcRSOvVq9HQWsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a8e4feeb-4f9e-44d2-ac61-dec5b763d40f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-51cb-7479-a621-736ab7318368.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-51cb-7479-a621-736ab7318368",
        "storage_key": "property/6767906449167616/01a0b66a-51cb-7479-a621-736ab7318368.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac19-77dc-9e98-97ab66e4e3c0",
        "storage_key": "property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3bdbb081-f106-484b-ba56-ad7112fb4aae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "AMC Studio 28",
      "poi_type": "Entertainment",
      "poi_address": "12075 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Movie theater and dine-in eatery offering the latest releases, as well as a bar and snack counter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc991-19af-707f-bfcc-313e6ab2a315.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-19af-707f-bfcc-313e6ab2a315",
        "storage_key": "property/6767906449167616/019fc991-19af-707f-bfcc-313e6ab2a315.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-studio-28?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16780991066006934845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-studio-28",
      "poi_latitude": "38.907307",
      "poi_longitude": "-94.7671361",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-393-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac19-77dc-9e98-97ab66e4e3c0",
        "storage_key": "property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3tZuHWVwIcRPdVYDHcO4ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5c403fef-1da4-4ed7-8700-f31a999143cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-87d3-722b-b6bb-3594fe7b70bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-87d3-722b-b6bb-3594fe7b70bb",
        "storage_key": "property/6767906449167616/019ff6a8-87d3-722b-b6bb-3594fe7b70bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac19-77dc-9e98-97ab66e4e3c0",
        "storage_key": "property/6767906449167616/019ff6a8-ac19-77dc-9e98-97ab66e4e3c0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fa52cc28-7b6e-48d5-b70f-a83184dab28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-7f41-75ed-864a-34cb55b058fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-7f41-75ed-864a-34cb55b058fa",
        "storage_key": "property/6767906449167616/019ff6a8-7f41-75ed-864a-34cb55b058fa.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cad39476-cca9-4a03-9039-b8019d3bac82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Mahaffie Stagecoach Stop-Farm",
      "poi_type": "Entertainment",
      "poi_address": "1200 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_long_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-9ecf-7469-8830-72f0365e7983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-9ecf-7469-8830-72f0365e7983",
        "storage_key": "property/6767906449167616/019fc98a-9ecf-7469-8830-72f0365e7983.webp",
        "width": 1200,
        "height": 965
      },
      "poi_business_url": "http://www.mahaffie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906880325698000129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-stagecoach-stop-farm",
      "poi_latitude": "38.8920954",
      "poi_longitude": "-94.7996569",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-971-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b610-74ac-96d6-da6fd6bcafd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b610-74ac-96d6-da6fd6bcafd0",
        "storage_key": "property/6767906449167616/019fc98b-b610-74ac-96d6-da6fd6bcafd0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f59bfeVwIcRARWVkKi9GEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b630afae-3004-4bb8-87a5-633e3b527248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Ernie Miller Park & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "909 North, KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_long_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc991-5c31-70c8-a793-9243533adb9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-5c31-70c8-a793-9243533adb9e",
        "storage_key": "property/6767906449167616/019fc991-5c31-70c8-a793-9243533adb9e.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://erniemiller.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769145388029025309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernie-miller-park--nature-center",
      "poi_latitude": "38.8967913",
      "poi_longitude": "-94.8409835",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-826-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt22HnSWWwIcRHZwNByofEFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_1593d358-0e0f-4d45-a6e9-f0dc69fd8921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-9cdc-711a-a3fd-671f1fa8f748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-9cdc-711a-a3fd-671f1fa8f748",
        "storage_key": "property/6767906449167616/019fc98a-9cdc-711a-a3fd-671f1fa8f748.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b610-74ac-96d6-da6fd6bcafd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b610-74ac-96d6-da6fd6bcafd0",
        "storage_key": "property/6767906449167616/019fc98b-b610-74ac-96d6-da6fd6bcafd0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_ed8302e6-287f-401d-9a4d-db8e56b638d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Arts And Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8788 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Cultural center featuring the Johnson County Museum, the KidScape experience, and a theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-554a-736a-8553-9290e7d00c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-554a-736a-8553-9290e7d00c2f",
        "storage_key": "property/6767906449167616/01a0b66a-554a-736a-8553-9290e7d00c2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcprd.com/327/Arts-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6564331375929992564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-arts-and-heritage-center",
      "poi_latitude": "38.9698449",
      "poi_longitude": "-94.6681692",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 913-826-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2a8po3rwIcRdCVCapswGVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_02648d6e-3ba6-48ca-995f-7e801779447f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-55a9-746c-b632-def79dae4393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-55a9-746c-b632-def79dae4393",
        "storage_key": "property/6767906449167616/01a0b66a-55a9-746c-b632-def79dae4393.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4580958955913278959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-square-park",
      "poi_latitude": "38.8829639",
      "poi_longitude": "-94.8200841",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyzGHrS9wIcR7_XaQebVkj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c00644fb-f94d-4042-b61c-8152c12948ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Lake Olathe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 S Lakeshore Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a beach, an obstacle course, a waterfall and cliffs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-a008-71af-a38f-ce894447d837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a008-71af-a38f-ce894447d837",
        "storage_key": "property/6767906449167616/019ff6a8-a008-71af-a38f-ce894447d837.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lake-olathe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6997584864379487297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olathe-park",
      "poi_latitude": "38.8735242",
      "poi_longitude": "-94.8731186",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-971-8973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtehEK9wIcRQUT9_ltqHGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8d87563c-cdf2-40c2-a7cd-cb8a624ad540",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Olathe Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "20333 W 151st St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-8f87-7347-a55d-d4b8a023f27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8f87-7347-a55d-d4b8a023f27d",
        "storage_key": "property/6767906449167616/019ff6a8-8f87-7347-a55d-d4b8a023f27d.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/olathe-hospital?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16276948923291160757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-hospital",
      "poi_latitude": "38.85260299999999",
      "poi_longitude": "-94.822969",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-445-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b6d4-7354-9f3e-087a1b5661a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b6d4-7354-9f3e-087a1b5661a8",
        "storage_key": "property/6767906449167616/019fc98b-b6d4-7354-9f3e-087a1b5661a8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQclTbs69wIcRtVDyh85W4-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_df27b6e4-6fa9-42de-884d-7bf2f165ad6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "AdventHealth Centra Care Olathe",
      "poi_type": "Health and Wellness",
      "poi_address": "14744 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc991-a8a8-74e8-8912-8697d2c23d3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-a8a8-74e8-8912-8697d2c23d3b",
        "storage_key": "property/6767906449167616/019fc991-a8a8-74e8-8912-8697d2c23d3b.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=17608835198424736316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-centra-care-olathe",
      "poi_latitude": "38.9132385",
      "poi_longitude": "-94.7574291",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-839-1759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwEcwBKVwIcRPGKAPlEmX_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4df40624-5ca8-4c7a-bcb5-90086f63ffa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13600 S Alden St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6d1-a38b-7529-b635-9118482ac67b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d1-a38b-7529-b635-9118482ac67b",
        "storage_key": "property/6767906449167616/019ff6d1-a38b-7529-b635-9118482ac67b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/577-olathe-ks/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4744990861186558058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "38.8814119",
      "poi_longitude": "-94.7584161",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-829-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac18-74b4-bd2d-70fd2494cad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac18-74b4-bd2d-70fd2494cad5",
        "storage_key": "property/6767906449167616/019ff6a8-ac18-74b4-bd2d-70fd2494cad5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfgVptq_wIcRauh_VwyY2UE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a631cfcc-edee-44fd-8552-4628eb7de3d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1785 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98f-deed-719e-8f75-18dc1d57eca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-deed-719e-8f75-18dc1d57eca0",
        "storage_key": "property/6767906449167616/019fc98f-deed-719e-8f75-18dc1d57eca0.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/olathe-ks-pharmacies/1785-s-mur-len-rd-olathe-ks-66062/storeid=5257?WT.mc_id=LS_GOOGLE_RX_5257",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868316038945963514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.855239",
      "poi_longitude": "-94.7806073",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-390-9892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac18-74b4-bd2d-70fd2494cad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac18-74b4-bd2d-70fd2494cad5",
        "storage_key": "property/6767906449167616/019ff6a8-ac18-74b4-bd2d-70fd2494cad5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRB-aVq-wIcR-v0NyNoD1JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_57e922f4-664f-4ca3-8e89-b2c2546937d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13509 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Chain fitness center with tanning, massage chairs, and updated equipment, as well as knowledgeable trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-c7c1-75fd-bf06-1b4ac7d6be4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-c7c1-75fd-bf06-1b4ac7d6be4d",
        "storage_key": "property/6767906449167616/019fc98a-c7c1-75fd-bf06-1b4ac7d6be4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/olathe-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17119566753725212893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.8828221",
      "poi_longitude": "-94.777165",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-732-9350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0mRs72_wIcR3ehgWELrlO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1fdf0b80-0035-4b80-9563-9ce034fda605",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1473 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-599d-77a8-8f49-dc4befcf4049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-599d-77a8-8f49-dc4befcf4049",
        "storage_key": "property/6767906449167616/01a0b66a-599d-77a8-8f49-dc4befcf4049.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/olathe-kansas-4211/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4211",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377659993054209647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "38.8536538",
      "poi_longitude": "-94.7957355",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-971-4060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdVoEmS-wIcRb2bnCGWQCv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_18a90a23-fe06-44a5-97a7-6f5c9584ea4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Olathe Pointe",
      "poi_type": "Shopping & Retail",
      "poi_address": "119th & Blackbob Rd, 66062 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Strip mall with a range of outlets including clothing, groceries, and a Chick-fil-A.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-9059-760d-8f7c-1285bcf0c3a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-9059-760d-8f7c-1285bcf0c3a8",
        "storage_key": "property/6767906449167616/019ff6a8-9059-760d-8f7c-1285bcf0c3a8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/43bJl3a",
      "poi_directions_map_url": "https://maps.google.com/?cid=5189893996330645376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-pointe",
      "poi_latitude": "38.910586",
      "poi_longitude": "-94.7578894",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b604-7249-85ec-287ff07fd32f",
        "storage_key": "property/6767906449167616/019fc98b-b604-7249-85ec-287ff07fd32f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7bi5fnCVwIcRgHc4qRc1Bkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bc5de5e1-3615-4cf6-be16-abb3c349b1f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "18101 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-8c04-7564-8133-b71b24bc0fcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-8c04-7564-8133-b71b24bc0fcb",
        "storage_key": "property/6767906449167616/019ff6a8-8c04-7564-8133-b71b24bc0fcb.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://www.clubpilates.com/location/olathe/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13039154569382708029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "38.9113169",
      "poi_longitude": "-94.7953422",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-286-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkXkTGCKVwIcRPcN3F_9h9LQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_4274afcd-2df1-4f71-bbae-8562857833f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "RoKC",
      "poi_type": "Health and Wellness",
      "poi_address": "654 N Central St, Olathe, KS 66061, USA",
      "poi_short_description": "Climbing gym with top-roping, bouldering, lead climbing, autobelays, and yoga classes, as well as a weight room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-9c72-766f-93fd-d2b4ea7683a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-9c72-766f-93fd-d2b4ea7683a8",
        "storage_key": "property/6767906449167616/019ff6a8-9c72-766f-93fd-d2b4ea7683a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.climbkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10448020602287777537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rokc",
      "poi_latitude": "38.890725",
      "poi_longitude": "-94.7954392",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-318-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrT3QAmmVwIcRAWdTvWHT_pA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_84b8eb40-2736-4098-bd16-20fc5ae9c49c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Heatherstone Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 123rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-97c2-74ed-9dbb-75cd43ea7889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-97c2-74ed-9dbb-75cd43ea7889",
        "storage_key": "property/6767906449167616/019ff6a8-97c2-74ed-9dbb-75cd43ea7889.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/heatherstone-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5225824788957923902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heatherstone-park",
      "poi_latitude": "38.9042043",
      "poi_longitude": "-94.744642",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4kIfyWVwIcRPopEPPXbhUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_21922ca7-425b-4dc6-ad87-f2d9dc833e58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Black Bob Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14500 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_long_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-fa26-76b9-8aef-993fcd68dc82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-fa26-76b9-8aef-993fcd68dc82",
        "storage_key": "property/6767906449167616/019fc98a-fa26-76b9-8aef-993fcd68dc82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/black-bob-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317087441858333318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-bob-park",
      "poi_latitude": "38.8583619",
      "poi_longitude": "-94.7539901",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTqNmKS_wIcRhgoMG4_Nqlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d23609cc-1db2-4094-bd47-f7d0f2a6e0d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16050 Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Vast park with an 18-hole golf course, athletic fields, a dog off-leash area, and a 40-acre lake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-e120-72b5-9fdf-a54a1b9b8864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-e120-72b5-9fdf-a54a1b9b8864",
        "storage_key": "property/6767906449167616/019fc98a-e120-72b5-9fdf-a54a1b9b8864.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jcprd.com/Facilities/Facility/Details/Heritage-Park-22",
      "poi_directions_map_url": "https://maps.google.com/?cid=9628716837042979252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "38.8308502",
      "poi_longitude": "-94.7528206",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-888-4713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVvVbW6_wIcRtAHFuvISoIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_751a175c-0800-47b2-922d-13cddb0bca23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Prairie Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "26325 W 135th St, Olathe, KS 66061, USA",
      "poi_short_description": "A 300-acre prairie preserve with wetlands, woodlands & wildlife plus trails & educational programs.",
      "poi_long_description": "A 300-acre prairie preserve with wetlands, woodlands & wildlife plus trails & educational programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-61e3-76c3-9356-75f8d00c9564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-61e3-76c3-9356-75f8d00c9564",
        "storage_key": "property/6767906449167616/01a0b66a-61e3-76c3-9356-75f8d00c9564.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ksoutdoors.com/KDWPT-Info/Locations/Museums-and-Nature-Centers/Olathe-Prairie-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3274751789830309639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-center",
      "poi_latitude": "38.8829006",
      "poi_longitude": "-94.890516",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-209-0207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXgvn6yiwIcRBwdpCGdBci0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_c139da33-344b-4244-a229-ea94379bf2a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Cedar Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15500 S Lone Elm Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Small lake featuring a playground, picnic facilities, and fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-9ce3-716c-8894-d48020d5edeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-9ce3-716c-8894-d48020d5edeb",
        "storage_key": "property/6767906449167616/019ff6a8-9ce3-716c-8894-d48020d5edeb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/cedar-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993153085847633081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-lake",
      "poi_latitude": "38.8457194",
      "poi_longitude": "-94.8432857",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5S-S629wIcRufyndBUZznw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_465d02b0-e993-4d49-9e2a-269e1c419c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Lone Elm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "21151 W 167th St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreational park offering nature trails, softball & soccer fields & covered picnicking facilities.",
      "poi_long_description": "Recreational park offering nature trails, softball & soccer fields & covered picnicking facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-5f25-77dc-8201-68ed4f5d8e3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-5f25-77dc-8201-68ed4f5d8e3f",
        "storage_key": "property/6767906449167616/01a0b66a-5f25-77dc-8201-68ed4f5d8e3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lone-elm-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14468140487514284466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-elm-park",
      "poi_latitude": "38.8228149",
      "poi_longitude": "-94.8303386",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbyJcuRW8wIcRsmG8Lh4pycg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_306817ba-87fe-44f1-a43b-c659cd8a8ddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Frisco Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 E Dennis Ave, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a gazebo & playground, plus basketball & volleyball courts, walking trail & fishing.",
      "poi_long_description": "Park featuring a gazebo & playground, plus basketball & volleyball courts, walking trail & fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc993-9b9d-76f7-b3d1-c95e64dffebf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-9b9d-76f7-b3d1-c95e64dffebf",
        "storage_key": "property/6767906449167616/019fc993-9b9d-76f7-b3d1-c95e64dffebf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/frisco-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9704081886323539806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-lake-park",
      "poi_latitude": "38.86967629999999",
      "poi_longitude": "-94.8023943",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b619-72d5-b72b-7be1c105536b",
        "storage_key": "property/6767906449167616/019fc98b-b619-72d5-b72b-7be1c105536b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbE4YAy-wIcRXv-dqQ_Tq4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_61048909-c244-4342-b776-aa4cb5aee1a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1701 W Old 56 Hwy, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0100f-675f-72c4-bd1b-9a44609a0876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-675f-72c4-bd1b-9a44609a0876",
        "storage_key": "property/6767906449167616/01a0100f-675f-72c4-bd1b-9a44609a0876.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/dept/transit/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259441942160797783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-transit",
      "poi_latitude": "38.8639984",
      "poi_longitude": "-94.8448333",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-362-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRjftqO9wIcRV_CsTkgB3lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_88a88ab5-5b2d-4ae2-a868-ba08028850b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-98e1-7609-938c-e36600a38f14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-98e1-7609-938c-e36600a38f14",
        "storage_key": "property/6767906449167616/019ff6a8-98e1-7609-938c-e36600a38f14.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac25-7329-b2c7-5ce1149d8ac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac25-7329-b2c7-5ce1149d8ac2",
        "storage_key": "property/6767906449167616/019ff6a8-ac25-7329-b2c7-5ce1149d8ac2.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_0f79f35e-ead3-4581-9948-809ff292b5ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Old 56 Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "912 S Chestnut St, Olathe, KS 66061, USA",
      "poi_short_description": "Old-fashioned eatery serving coffee, all-day breakfasts & homey diner classics in an updated space.",
      "poi_long_description": "Old-fashioned eatery serving coffee, all-day breakfasts & homey diner classics in an updated space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-6239-7129-8a32-508186fee99e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-6239-7129-8a32-508186fee99e",
        "storage_key": "property/6767906449167616/01a0b66a-6239-7129-8a32-508186fee99e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://olathe.old56familyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10586299816660311910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-56-family-restaurant",
      "poi_latitude": "38.868218",
      "poi_longitude": "-94.8182406",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-390-9905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b620-71ce-a7e9-ba2603bc80cd",
        "storage_key": "property/6767906449167616/019fc98b-b620-71ce-a7e9-ba2603bc80cd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzXmeee9wIcRZh_SOZgX6pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_f142d15e-ff66-4878-8c14-19188e714a1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "College Church of the Nazarene",
      "poi_type": "Transportation & Transit",
      "poi_address": "2020 E Sheridan St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-67a1-716c-9829-cf740a913f2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-67a1-716c-9829-cf740a913f2d",
        "storage_key": "property/6767906449167616/01a0b66a-67a1-716c-9829-cf740a913f2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.collegechurch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17049162991192464494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-church-of-the-nazarene",
      "poi_latitude": "38.8695631",
      "poi_longitude": "-94.7835181",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-764-4575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac25-7329-b2c7-5ce1149d8ac2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac25-7329-b2c7-5ce1149d8ac2",
        "storage_key": "property/6767906449167616/019ff6a8-ac25-7329-b2c7-5ce1149d8ac2.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bXzVz--wIcRblzD_2jLmuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_515b89ce-0242-4b9b-9bdc-a74ecb303a8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc993-665e-777d-9052-fcbda5bced8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-665e-777d-9052-fcbda5bced8a",
        "storage_key": "property/6767906449167616/019fc993-665e-777d-9052-fcbda5bced8a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "41.3",
      "poi_walking_minutes": "15 hours 19 mins",
      "poi_biking_minutes": "4 hours 34 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-cd0f-727a-be81-31bab78f781b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-cd0f-727a-be81-31bab78f781b",
        "storage_key": "property/6767906449167616/019fc98b-cd0f-727a-be81-31bab78f781b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_6b6ce4b6-d8af-4ae8-a0f0-dea03b0b944c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98a-f37b-712c-b907-d44136a9a05a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-f37b-712c-b907-d44136a9a05a",
        "storage_key": "property/6767906449167616/019fc98a-f37b-712c-b907-d44136a9a05a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_62193f73-90ff-46ca-b467-a442f61aa97c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "ALDI Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10505 S K 7 Hwy, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-67b8-72bc-9ebf-ef6b8a0cc365.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-67b8-72bc-9ebf-ef6b8a0cc365",
        "storage_key": "property/6767906449167616/01a0b66a-67b8-72bc-9ebf-ef6b8a0cc365.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.aldi.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14098322603656438564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi-distribution-center",
      "poi_latitude": "38.9371947",
      "poi_longitude": "-94.8485368",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 913-768-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5NDfvuWwIcRJGPNP7ZNp8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_4d9d7b25-19d3-4a2e-85e6-3721c18812a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Honeywell Aerospace, Olathe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "23500 W 105th St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-a52a-7645-a225-6fba37fbdb27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a8-a52a-7645-a225-6fba37fbdb27",
        "storage_key": "property/6767906449167616/019ff6a8-a52a-7645-a225-6fba37fbdb27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://honeywellaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17457818006217975346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell-aerospace-olathe",
      "poi_latitude": "38.93807",
      "poi_longitude": "-94.8562769",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 913-712-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWE9C-SXwIcRMmYKLvugRvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_69d9ec97-8de5-4227-92db-fa3aae14af6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Farmers Insurance - Jon Wren Agency",
      "poi_type": "Major Employers & Offices",
      "poi_address": "234 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-6a75-758c-91c9-4b9e631aa161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-6a75-758c-91c9-4b9e631aa161",
        "storage_key": "property/6767906449167616/01a0b66a-6a75-758c-91c9-4b9e631aa161.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jonwrenagency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10511535783564524590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farmers-insurance---jon-wren-agency",
      "poi_latitude": "38.8793015",
      "poi_longitude": "-94.8191804",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-839-8422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9iIOw2VwIcRLrwrRxp64JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_5ea4f235-64bb-48ea-b52d-8621a99f9a18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Husqvarna Construction Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17400 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "Construction company offering quality equipment along with training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-69a8-72ee-b786-e669eb0ec9bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-69a8-72ee-b786-e669eb0ec9bd",
        "storage_key": "property/6767906449167616/01a0b66a-69a8-72ee-b786-e669eb0ec9bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.husqvarna.com/us/construction/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15077997571752706308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "husqvarna-construction-products",
      "poi_latitude": "38.9148372",
      "poi_longitude": "-94.7878107",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-928-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoRx0GL-VwIcRBMGFpOfOP9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_0c7ddc24-f2ed-4176-81e9-6a69d2b384fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc993-94e0-7668-9773-15d0402c0b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-94e0-7668-9773-15d0402c0b9a",
        "storage_key": "property/6767906449167616/019fc993-94e0-7668-9773-15d0402c0b9a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac2a-700d-9c51-05328c4d554c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac2a-700d-9c51-05328c4d554c",
        "storage_key": "property/6767906449167616/019ff6a8-ac2a-700d-9c51-05328c4d554c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ba2d119a-ef4a-4cf3-9103-37e1603e1f02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Olathe Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14160 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc993-954c-7526-96e8-42bbc0350f6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-954c-7526-96e8-42bbc0350f6d",
        "storage_key": "property/6767906449167616/019fc993-954c-7526-96e8-42bbc0350f6d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.olatheschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2471559516784985002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-public-schools",
      "poi_latitude": "38.8710187",
      "poi_longitude": "-94.7620475",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b606-72fd-b8a1-c837558ec1be",
        "storage_key": "property/6767906449167616/019fc98b-b606-72fd-b8a1-c837558ec1be.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAyR-Mci_wIcRqoM0H0m-TCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15c1c5e7-da4a-473b-a88c-1414b41953b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "City of Olathe City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0100f-6bd2-71ef-a146-c05e0dd32564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100f-6bd2-71ef-a146-c05e0dd32564",
        "storage_key": "property/6767906449167616/01a0100f-6bd2-71ef-a146-c05e0dd32564.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "http://www.olatheks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9492556933527452182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-olathe-city-hall",
      "poi_latitude": "38.883783",
      "poi_longitude": "-94.8192239",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-971-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019ff6a8-ac2a-700d-9c51-05328c4d554c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a8-ac2a-700d-9c51-05328c4d554c",
        "storage_key": "property/6767906449167616/019ff6a8-ac2a-700d-9c51-05328c4d554c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUibmfm9wIcRFjoTwTxWvIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c16194e4-e4ed-4138-b155-fef95b5c04e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "poi_name": "Amazon Delivery Station AMZL - DKS3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10800 Mill Creek Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Warehouse that could be a point of interest.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66a-6e4d-7048-8401-278c81261c79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b66a-6e4d-7048-8401-278c81261c79",
        "storage_key": "property/6767906449167616/01a0b66a-6e4d-7048-8401-278c81261c79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6463213431104758459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-delivery-station-amzl---dks3",
      "poi_latitude": "38.9333011",
      "poi_longitude": "-94.7894443",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-b614-75d9-a576-046f4c3c3a65",
        "storage_key": "property/6767906449167616/019fc98b-b614-75d9-a576-046f4c3c3a65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbi7yseVwIcRu2KIPF_ysVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    }
  ],
  "office_hours": [
    {
      "id": "ec_57d725168cb619802b352750",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7c0769bc07243c63ccff55bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_356f8a48bc9a1486f4f9d41e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fe5ccf7d7b8be59d915504ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c6865deaf81dec8afbbf6a34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5f687825a9ae2e4afc2fd17c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_ca0d5ac7-e201-4c08-ad65-c5d8c6cc4485",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "rating": "5.0",
      "name": "Janet Miller",
      "text": "I am a resident of Stone Post Lakeside Apartments. I love this place and it is so easy to work with Clay in the office. He always helps me out with whatever and is always very friendly and professional. The whole staff and maintenance is so easy to work with. I give all of them kudos! OK",
      "date": "2026-08-18",
      "title": ""
    },
    {
      "id": "custom_0dd877cf-5f42-44c4-b9d8-88cb9e98f03f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "rating": "4.0",
      "name": "Samee Hill",
      "text": "I lived here for about 3 years and the apartments are great. I chose to live in these apartments because of how spacious and open the floor plans are. Most other complexes are more expensive and claim to have spacious floorplans, but this complex more than delivers on that and that staff was absolutely phenomenal in the time that I lived there. I had only one issue with one of the managers  that didn't always seem like he knew how to explain things very well, but even he was still very nice and would always try to be helpful even the maintenance guys were always very nice and helpful. The only negative thing I actually encountered while living there would be the fact that the lake would get very dirty and smelly during the warmer months and it would make walking around the trail not very pleasant, but I don't know if that would be of anyone's fault, and everything else was fantastic and I even have friends that are moving here soon and I hope they enjoy it as much as I did.",
      "date": "2025-06-29",
      "title": ""
    },
    {
      "id": "custom_47656af9-2de6-41f6-ab93-0269d934671b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "rating": "5.0",
      "name": "Caleb Shook",
      "text": "From day 1, this was a great experience and great place to live. My wife, two kids and myself lived here while our house was being built.\n\nOur home-build was delayed past the \"move-out\" date that I elected with the apartment. The front office allowed me to push my \"move-out\" date. When it was delayed again, they said that the new tenant already expected to move in, so I would not be able to delay again- BUT they tried anyway! They literally called the new tenant to see how flexible their move in date was, and successfully made it possible to push our \"move-out\" date, again.\n\nThe time spent while living there was also great.\n- The apartment, obviously not brand new, was still in great condition and clearly kept-up.\n- The pool was never over crowded.\n- The walking trail was a nice bonus.\n- The view of the lake was a constant enjoyment.\n- The other tenants that we met there were all very friendly\n- We received way more of our deposit back than we deserved- to be frank.\n- And the front office, again, could not have been more accommodating\n\nIf you're considering living here, and can get in, I would highly recommend. We picked Stonepost for the price and lake view, but got so much more. Truly a great place.",
      "date": "2022-06-17",
      "title": "false"
    },
    {
      "id": "custom_9ec2245b-4ee8-4029-ac9b-eafae9ab1ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "rating": "5",
      "name": "Kevin V",
      "text": "Milly was an excellent help and answered all my questions with ease, greatly appreciate everything she's doing !",
      "date": "2026-09-02",
      "title": "false"
    },
    {
      "id": "custom_6c1480f3-a3fd-42a3-a198-ac13f604e343",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "rating": "5",
      "name": "Brenda Barefoot",
      "text": "Thank you! The maintenance crew are awesome!",
      "date": "2026-09-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_3df78f87292950c5767393bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-1df4-7316-961f-02d140436fa9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-1df4-7316-961f-02d140436fa9",
        "storage_key": "property/6767906449167616/01a0b66d-1df4-7316-961f-02d140436fa9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BCobmnmaUgg"
    },
    {
      "id": "ec_ab812f77d33864bc68549b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-1995-7030-9ed7-0978e5af5240.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-1995-7030-9ed7-0978e5af5240",
        "storage_key": "property/6767906449167616/01a0b66d-1995-7030-9ed7-0978e5af5240.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Taos",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PhzXmEsrqrQ"
    },
    {
      "id": "ec_868d347b83446a12090b7e5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-1114-751e-873f-42e95a39fc8e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-1114-751e-873f-42e95a39fc8e",
        "storage_key": "property/6767906449167616/01a0b66d-1114-751e-873f-42e95a39fc8e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Aztec",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eW5SjCpJ665"
    },
    {
      "id": "ec_0be1fa23710ef12cceb6ba49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-1c63-733f-8012-c064f3663643.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-1c63-733f-8012-c064f3663643",
        "storage_key": "property/6767906449167616/01a0b66d-1c63-733f-8012-c064f3663643.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Raton",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SmPGc6Wgqyj"
    },
    {
      "id": "ec_50fced879e0633c99f747f74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-0cf2-75cd-87d0-7abbfd346acd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-0cf2-75cd-87d0-7abbfd346acd",
        "storage_key": "property/6767906449167616/01a0b66d-0cf2-75cd-87d0-7abbfd346acd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Navajo",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kCQrRWDEb8P"
    },
    {
      "id": "ec_2d3749afe1468a8809be94f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-3794-7330-9a8c-467f01b6edec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-3794-7330-9a8c-467f01b6edec",
        "storage_key": "property/6767906449167616/01a0b66d-3794-7330-9a8c-467f01b6edec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hidalgo",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kQtLwsZHyDw"
    },
    {
      "id": "ec_8fd21c36417a9e78f22acdd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167616/01a0b66d-3941-770a-a01a-a0c8f1c0a631.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b66d-3941-770a-a01a-a0c8f1c0a631",
        "storage_key": "property/6767906449167616/01a0b66d-3941-770a-a01a-a0c8f1c0a631.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Valencia",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gHxdiJTrRgw"
    }
  ],
  "faqs": [
    {
      "id": "custom_3dd55810-56b2-4a5b-8423-bf59bf291711",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_11f0141b-be1d-44b6-a738-86a12cd9dd82",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_cdff30a7-38b5-4a73-8238-a7d106eb2290",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3d4af641-70dc-4ff3-83d5-14f5f660e817",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d63c027d-58f6-4abb-a27e-4afb07929c53",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_987b1ff0-ed65-4332-971b-d6ecdf6d6579",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_0efb6fa2-52e5-4576-a8f3-a059732fb05b",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_53190739-4bb9-4e1a-bab9-daa03b4fc7ec",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4e79629d-e437-4be1-bf88-9db001179ce5",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, sewer, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_bcd1dc58-1040-4ba0-8279-19aa66f19662",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2c143c1c-6f26-46e9-a126-1b923856d64d",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_78263fd7-8e77-43c4-ab7a-6fbaa0196a5a",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c4a82841-552b-48fa-b48d-321437f36341",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports and garages. Please <a href=\"/contact-us\">contact the office</a> for our most current pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_cb253ef7-e51b-48be-a04e-559e7cd9b57d",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_da180bba-bce3-4163-b15a-53a64c492920",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_859b57c9-c0aa-4862-a12e-27dd4463dcd4",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4953-729e-abe2-0ae3b33e15ff",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Stonepost Lakeside Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616"
    },
    {
      "lead_collector_id": "01a0c9ac-49e0-742f-b39e-3ee623c5b87f",
      "lead_source": "LANDING_PAGE",
      "name": "Stonepost Lakeside Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-olathe-ks-stonepost",
      "search_query": "in unit laundry apartments Olathe KS",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Olathe, KS",
      "h2_subtitle": "Discover Stonepost Lakeside, where Olathe, KS apartments offer convenient in-unit laundry. Enjoy the ease of home living right by the lake.",
      "page_copy": "Looking for in-unit laundry apartments in Olathe, KS? Stonepost Lakeside Apartment Homes offer the ideal solution with in-home washers and dryers available in every unit. Nestled in the serene Marquiss Lakeside neighborhood, our one, two, and three-bedroom layouts provide not only the appliance convenience but also feature private outdoor spaces for your enjoyment. \n\nOur beautiful community offers the perfect balance of waterfront relaxation and modern amenities. Located near 135th Street and I-35, you'll have quick access to all that Olathe has to offer. Inside our homes, you'll find cozy wood-burning fireplaces, spacious eat-in kitchens with pantries, and elegant 9ft ceilings. Schedule a visit today to explore how Stonepost Lakeside Apartment Homes can meet all your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Olathe, KS",
      "seo_description": "Explore Stonepost Lakeside Apartment Homes offering in-unit laundry, waterfront views, and more in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-johnson-county-stonepost",
      "search_query": "pet friendly apartments in Johnson County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Johnson County",
      "h2_subtitle": "Discover pet-friendly living at Stonepost Lakeside. Our Johnson County apartments welcome your furry friends with open arms.",
      "page_copy": "Finding pet-friendly apartments in Johnson County is easy with Stonepost Lakeside Apartment Homes. Our community embraces your furry companions amidst a relaxed waterfront setting. Located in the scenic Marquiss Lakeside neighborhood in Olathe, KS, we offer spacious one, two, and three-bedroom layouts that welcome both you and your pets.\n\nEnjoy modern conveniences like in-unit washers and dryers, private outdoor spaces, and cozy wood-burning fireplaces. Our pet-friendly community is designed to offer both comfort and easy access to nearby amenities, with major roads like 135th Street and I-35 just minutes away. Come experience a harmonious blend of lakeside tranquility and pet-friendly living at Stonepost Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Johnson County, KS",
      "seo_description": "Stonepost Lakeside Apartment Homes in Johnson County offers pet-friendly living with scenic waterfront views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pool-olathe-stonepost",
      "search_query": "apartments with swimming pool Olathe",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Olathe",
      "h2_subtitle": "Dive into relaxation at Stonepost Lakeside. Our Olathe apartments feature a refreshing swimming pool and more.",
      "page_copy": "If you're searching for apartments with a swimming pool in Olathe, look no further than Stonepost Lakeside Apartment Homes. Our community offers the perfect oasis with a refreshing swimming pool that enhances our already inviting lakeside setting. \n\nSituated in the tranquil Marquiss Lakeside neighborhood, our one, two, and three-bedroom layouts provide a serene living experience with all the modern conveniences you desire. Enjoy the ease of in-unit laundry, private outdoor spaces, and a cozy wood-burning fireplace in select units. Located with quick access to 135th Street and I-35, Stonepost Lakeside combines the benefits of a prime location with the pleasures of resort-style amenities right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Olathe, KS",
      "seo_description": "Experience Stonepost Lakeside in Olathe with a swimming pool, lakeside views, and modern amenities for the perfect lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "dog-park-apartments-marquiss-lakeside-stonepost",
      "search_query": "dog park apartments Marquiss Lakeside",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Marquiss Lakeside",
      "h2_subtitle": "Stonepost Lakeside offers dog park access for pet lovers in Marquiss Lakeside. Enjoy pet-friendly living just steps from your door.",
      "page_copy": "Looking for dog park apartments in Marquiss Lakeside? Stonepost Lakeside Apartment Homes is the perfect place for you and your furry companions. Set against a peaceful waterfront backdrop, our community welcomes pets and offers convenient access to pet-friendly amenities. \n\nStonepost Lakeside provides spacious one, two, and three-bedroom floor plans, each outfitted with in-unit washers and dryers and private outdoor spaces. Enhance your living experience with our cozy wood-burning fireplaces and modern kitchens featuring pantries. Located close to 135th Street and I-35, you and your pet will enjoy easy access to all the local benefits of Olathe while coming home to a community that truly values pet-friendly living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Marquiss Lakeside, KS",
      "seo_description": "Live at Stonepost Lakeside with dog park access and pet-friendly amenities in Marquiss Lakeside, offering prime features for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-near-66062-stonepost",
      "search_query": "air-conditioned apartments near 66062",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near 66062",
      "h2_subtitle": "Stay cool at Stonepost Lakeside. Our air-conditioned apartments near 66062 provide comfort year-round in a scenic setting.",
      "page_copy": "Searching for air-conditioned apartments near 66062? Stonepost Lakeside Apartment Homes in Olathe offers the perfect refuge from the heat. With modern air-conditioned units, you can enjoy comfortable living in every season, all within a stunning lakeside environment.\n\nOur community features spacious one, two, and three-bedroom floor plans that include in-unit washers and dryers, and private outdoor spaces, ensuring both comfort and convenience. Located in the peaceful Marquiss Lakeside neighborhood, just minutes from 135th Street and I-35, Stonepost Lakeside combines tranquil living with easy access to Olathe's amenities. Experience lakeside serenity and modern comfort all year round.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Near 66062, Olathe",
      "seo_description": "Find comfort at Stonepost Lakeside with air-conditioned apartments near 66062, offering ideal living conditions in a beautiful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-olathe-ks-stonepost",
      "search_query": "one bedroom apartments olathe ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Olathe, KS",
      "h2_subtitle": "Discover the ideal one bedroom apartment at Stonepost Lakeside in Olathe, KS. Comfort and style await in our well-designed layouts.",
      "page_copy": "For those seeking one bedroom apartments in Olathe, KS, Stonepost Lakeside Apartment Homes offers beautifully designed spaces that blend comfort and style. Nestled in the serene Marquiss Lakeside area, our one-bedroom units feature air conditioning, in-unit washers and dryers, and private outdoor spaces, perfect for enjoying your morning coffee or evening relaxation.\n\nResidents benefit from convenient amenities, including thoughtful design elements like spacious eat-in kitchens and cozy wood-burning fireplaces in select units. Our prime location offers easy access to major highways like 135th Street and I-35, ensuring you're always connected to the best of Olathe and beyond. Experience the perfect combination of lakeside tranquility and modern living at Stonepost Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Olathe, KS",
      "seo_description": "Explore one bedroom apartments at Stonepost Lakeside in Olathe, KS, offering the ideal mix of style, comfort, and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-johnson-county-stonepost",
      "search_query": "two bedroom apartments near johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Johnson County",
      "h2_subtitle": "Find spacious two bedroom apartments near Johnson County at Stonepost Lakeside. Enjoy modern comforts in a serene setting.",
      "page_copy": "Looking for two bedroom apartments near Johnson County? Stonepost Lakeside Apartment Homes offer the perfect balance of convenience and tranquility. Situated in the picturesque Marquiss Lakeside area, our two-bedroom units boast spacious layouts with in-unit washers and dryers, 9ft ceilings, and private outdoor spaces that bring the beauty of nature to your doorstep.\n\nOur community embraces modern comfort, featuring air-conditioned living spaces and amenities such as cozy wood-burning fireplaces in select units. With easy access to major highways like 135th Street and I-35, living at Stonepost Lakeside ensures seamless connectivity to the best of Johnson County and beyond. Discover lakeside living where every detail caters to your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Johnson County, KS",
      "seo_description": "Discover two bedroom apartments at Stonepost Lakeside near Johnson County, offering spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-marquiss-lakeside-stonepost",
      "search_query": "three bedroom apartments marquiss lakeside",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Marquiss Lakeside",
      "h2_subtitle": "Explore spacious three-bedroom apartments in Marquiss Lakeside at Stonepost Lakeside. Experience waterfront living with unmatched convenience.",
      "page_copy": "Discover the ideal three-bedroom apartments in Marquiss Lakeside at Stonepost Lakeside Apartment Homes. Our community offers a perfect retreat with its serene waterfront setting and spacious living options. Each three-bedroom unit is thoughtfully designed, featuring air conditioning, in-unit washers and dryers, and ample private outdoor spaces that invite you to enjoy the surrounding natural beauty.\n\nResidents at Stonepost Lakeside enjoy a range of amenities, including eat-in kitchens with pantries and the comfort of cozy wood-burning fireplaces in select apartments. Conveniently located with easy access to major routes like 135th Street and I-35, you'll find everything you need close at hand. Embrace a perfect blend of tranquility and accessibility at our picturesque Marquiss Lakeside community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Marquiss Lakeside",
      "seo_description": "Find perfect three-bedroom apartments at Stonepost Lakeside in Marquiss Lakeside, offering ample living space and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-near-walnut-grove-elementary-olathe-ks-stonepost",
      "search_query": "apartments near Walnut Grove Elementary School Olathe KS",
      "category": "School",
      "h1_title": "Apartments Near Walnut Grove Elementary, Olathe",
      "h2_subtitle": "Discover apartments near Walnut Grove Elementary School in Olathe, KS. Enjoy comfortable living at Stonepost Lakeside.",
      "page_copy": "If you're searching for apartments near Walnut Grove Elementary School in Olathe, KS, Stonepost Lakeside Apartment Homes makes an excellent choice. Our inviting community offers a range of layouts, including one-, two-, and three-bedroom options, designed to meet a variety of needs. With air-conditioned interiors, in-home washers and dryers, and private outdoor spaces, you'll find all the comforts of home here.\n\nBeyond our well-appointed living spaces, residents enjoy a variety of amenities such as eat-in kitchens with pantries and cozy wood-burning fireplaces available in select units. Located in close proximity to 135th Street and I-35, our apartments provide easy access to local schools and amenities, making daily commutes convenient. Experience the perfect balance of location and lifestyle at Stonepost Lakeside today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Walnut Grove Elementary, Olathe",
      "seo_description": "Explore apartments near Walnut Grove Elementary School at Stonepost Lakeside in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-close-to-regency-place-elementary-stonepost",
      "search_query": "apartments close to Regency Place Elementary School Johnson County",
      "category": "School",
      "h1_title": "Apartments Close to Regency Place Elementary",
      "h2_subtitle": "Find apartments close to Regency Place Elementary School in Johnson County. Stonepost Lakeside offers a welcoming community.",
      "page_copy": "Searching for apartments close to Regency Place Elementary School in Johnson County? Stonepost Lakeside Apartment Homes offers a prime location near the school. Our community provides a peaceful lakeside setting with a selection of one-, two-, and three-bedroom floor plans, each featuring in-home washers and dryers, high ceilings, and spacious outdoor patios or balconies.\n\nStonepost Lakeside is more than just a place to live; it's a community offering comfortable amenities such as eat-in kitchens with ample pantries and optional wood-burning fireplaces in select homes. Strategically located near major routes like 135th Street and I-35, our residents enjoy easy access to local schools and conveniences. Experience a harmonious blend of accessibility and serenity at Stonepost Lakeside, perfectly suited for your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Regency Place Elementary",
      "seo_description": "Discover apartments near Regency Place Elementary School in Johnson County at Stonepost Lakeside, in a peaceful lakeside setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "stonepost-lakeside-apts-near-ravenwood-elementary",
      "search_query": "Stonepost Lakeside Apts near Ravenwood Elementary School",
      "category": "School",
      "h1_title": "Stonepost Lakeside Apts Near Ravenwood Elementary",
      "h2_subtitle": "Explore the convenience of living at Stonepost Lakeside Apts, situated near Ravenwood Elementary School in a serene lakeside setting.",
      "page_copy": "Experience the best of both education and serenity at Stonepost Lakeside Apartment Homes, conveniently located near Ravenwood Elementary School. Our community, nestled in a peaceful waterfront setting, offers one-, two-, and three-bedroom apartments that feature modern amenities like in-home washers and dryers, air conditioning, and inviting outdoor spaces. \n\nStonepost Lakeside not only provides a tranquil environment but also boasts convenient access to the Olathe area's local amenities and schools. Our residents enjoy comfortable interiors with eat-in kitchens, complete with pantries, and the option for a cozy wood-burning fireplace in select units. With easy connectivity to major roads such as 135th Street and I-35, getting anywhere you need is a breeze. Discover education and leisure in perfect harmony at Stonepost Lakeside Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonepost Lakeside Apts Near Ravenwood Elementary",
      "seo_description": "Live at Stonepost Lakeside Apts near Ravenwood Elementary, offering comfort and convenience in a lakeside community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "rentals-near-mahaffie-elementary-school-olathe",
      "search_query": "rentals near Mahaffie Elementary School in Olathe",
      "category": "School",
      "h1_title": "Rentals Near Mahaffie Elementary, Olathe",
      "h2_subtitle": "Discover ideal rentals near Mahaffie Elementary School in Olathe. Enjoy comfortable living at Stonepost Lakeside Apartment Homes.",
      "page_copy": "Looking for rentals near Mahaffie Elementary School in Olathe? Stonepost Lakeside Apartment Homes offers a desirable location with both tranquility and convenience. Our community features spacious one-, two-, and three-bedroom apartments, each equipped with in-home washers and dryers, and private outdoor spaces perfect for relaxation. \n\nAt Stonepost Lakeside, residents benefit from a variety of thoughtful amenities, including eat-in kitchens with pantries and the option for a charming wood-burning fireplace in select homes. Our strategic location provides easy access to major thoroughfares like 135th Street and I-35, ensuring a quick commute to local schools and amenities. Experience a perfect blend of comfortable living and accessibility at Stonepost Lakeside, just a short distance from Mahaffie Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Mahaffie Elementary, Olathe",
      "seo_description": "Explore Stonepost Lakeside rentals near Mahaffie Elementary School in Olathe, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-by-pioneer-trail-middle-school-66062",
      "search_query": "apartments by Pioneer Trail Middle School 66062",
      "category": "School",
      "h1_title": "Apartments by Pioneer Trail Middle School",
      "h2_subtitle": "Find your new home at Stonepost Lakeside Apartments, conveniently located by Pioneer Trail Middle School in the 66062 area.",
      "page_copy": "If you're searching for apartments by Pioneer Trail Middle School in the 66062 area, Stonepost Lakeside Apartment Homes offer an unrivaled choice. Set in a picturesque lakeside environment, our community provides easy access to local educational institutions, including Pioneer Trail Middle School.\n\nOur thoughtfully designed one-, two-, and three-bedroom apartments come complete with in-home washers and dryers, high ceilings, and serene private outdoor spaces. Residents have access to modern comforts like eat-in kitchens equipped with ample pantries and the option of wood-burning fireplaces in select homes. With easy connectivity to routes such as 135th Street and I-35, Stonepost Lakeside ensures you're perfectly positioned for both convenience and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Pioneer Trail Middle School",
      "seo_description": "Discover Stonepost Lakeside Apartments by Pioneer Trail Middle School in the 66062 area, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "olathe-south-high-school-apartments-marquiss-lakeside",
      "search_query": "Olathe South High School apartments Marquiss Lakeside",
      "category": "School",
      "h1_title": "Apartments Near Olathe South High School",
      "h2_subtitle": "Discover Stonepost Lakeside Apartments in Marquiss Lakeside, conveniently located near Olathe South High School.",
      "page_copy": "Nestled in the charming Marquiss Lakeside neighborhood, Stonepost Lakeside Apartment Homes offer an ideal location near Olathe South High School. Our one-, two-, and three-bedroom apartments provide a perfect blend of comfort and convenience, making them an excellent choice for anyone seeking a convenient home.\n\nResidents enjoy a tranquil lakeside setting with modern features including in-home washers and dryers, spacious floor plans, and private outdoor spaces. The community also boasts an eat-in kitchen with pantry options and wood-burning fireplaces in select homes. With seamless access to major roads such as 135th Street and I-35, your commute is both quick and efficient. Experience a lifestyle where education and elevated living meet at Stonepost Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Olathe South High School",
      "seo_description": "Find your ideal home at Stonepost Lakeside, near Olathe South High School in Marquiss Lakeside, offering comfort and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "stonepost-lakeside-near-johnson-county-community-college",
      "search_query": "Stonepost Lakeside near Johnson County Community College",
      "category": "School",
      "h1_title": "Stonepost Lakeside: Close to JCCC",
      "h2_subtitle": "Stonepost Lakeside Apartments provide the perfect homebase near Johnson County Community College, designed for student convenience.",
      "page_copy": "For those attending or working at Johnson County Community College, Stonepost Lakeside Apartment Homes serves as a prime residence. Located strategically for easy access to JCCC, our community offers a serene lakeside ambiance coupled with modern comforts. Choose from spacious one-, two-, or three-bedroom layouts, each featuring in-home washers and dryers, tall 9ft ceilings, and inviting private outdoor areas.\n\nAmenities such as eat-in kitchens equipped with pantries and the option for cozy wood-burning fireplaces enhance your living experience at Stonepost Lakeside. Our proximity to major roads including 135th Street and I-35 ensures swift travel across the area, making our apartments not just a place to stay, but a place to thrive. Enjoy balanced lakeside living close to educational pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonepost Lakeside: Close to JCCC",
      "seo_description": "Live at Stonepost Lakeside Apartments, near Johnson County Community College, offering convenience and a serene lakeside setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-near-johnson-county-square-park-olathe",
      "search_query": "apartments near Johnson County Square Park Olathe",
      "category": "Park",
      "h1_title": "Apartments Near Johnson County Square Park",
      "h2_subtitle": "Discover Stonepost Lakeside Apartments, ideally located near Johnson County Square Park in Olathe, offering outdoor adventure and comfort.",
      "page_copy": "Experience the best of outdoor living at Stonepost Lakeside Apartment Homes, beautifully situated near Johnson County Square Park in Olathe. Our community provides a perfect retreat with stunning lakeside views and direct access to recreational spots such as the nearby park. Ideal for outdoor enthusiasts, our apartments blend leisure with a convenient lifestyle.\n\nChoose from a range of one-, two-, and three-bedroom floor plans, each featuring modern amenities like in-home washers and dryers, vaulted 9ft ceilings, and inviting private outdoor spaces. Our apartments come equipped with eat-in kitchens that include ample pantry space, and the charm of wood-burning fireplaces is optional. With seamless connections via 135th Street and I-35, residing at Stonepost Lakeside means effortless access to both nature and urban conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Square Park",
      "seo_description": "Find your perfect home at Stonepost Lakeside, close to Johnson County Square Park in Olathe, combining natural beauty with modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "olathe-apartments-close-to-lake-olathe-park",
      "search_query": "Olathe apartments close to Lake Olathe Park",
      "category": "Park",
      "h1_title": "Olathe Apartments Near Lake Olathe Park",
      "h2_subtitle": "Stonepost Lakeside offers prime Olathe apartments near the recreational haven of Lake Olathe Park, perfect for outdoor enthusiasts.",
      "page_copy": "Stonepost Lakeside Apartment Homes are ideally located for those who crave both tranquility and outdoor fun, with close proximity to Lake Olathe Park. Our one-, two-, and three-bedroom apartments make the perfect abode for those who want easy access to nature while enjoying the comforts of modern apartment living.\n\nResidents at Stonepost Lakeside benefit from spacious layouts featuring in-home washers and dryers, elevated 9ft ceilings, and personal outdoor spaces. Our community is equipped with amenities like eat-in kitchens and select units with inviting wood-burning fireplaces. With convenient routes via 135th Street and I-35, Lake Olathe Park becomes a natural extension of your backyard, allowing for weekend adventures and daily relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe Apartments Near Lake Olathe Park",
      "seo_description": "Live at Stonepost Lakeside Apartments in Olathe, near Lake Olathe Park, combining serene living with outdoor adventure.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-near-heatherstone-park-ks",
      "search_query": "apartments near Heatherstone Park KS",
      "category": "Park",
      "h1_title": "Apartments Near Heatherstone Park, KS",
      "h2_subtitle": "Discover Stonepost Lakeside Apartments, conveniently located near Heatherstone Park, KS, offering a blend of comfort and outdoor recreation.",
      "page_copy": "Stonepost Lakeside Apartment Homes provide an ideal living experience for those seeking proximity to Heatherstone Park in Kansas. Our lakeside community not only offers direct access to beautiful natural settings but also provides a tranquil living environment. Choose from our spacious one-, two-, or three-bedroom apartment options featuring modern conveniences like in-home washers and dryers, and generous private balconies or patios.\n\nEnjoy amenities that complement your lifestyle, including eat-in kitchens with pantries and optional cozy wood-burning fireplaces. Our apartments are designed for easy living with 9ft ceilings and prime access to major thoroughfares like 135th Street and I-35. Whether taking a leisurely walk in Heatherstone Park or relaxing in your comfortable home, Stonepost Lakeside offers the perfect location and amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Heatherstone Park, KS",
      "seo_description": "Experience life at Stonepost Lakeside Apartment Homes, near Heatherstone Park, KS. Enjoy lakeside tranquility and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "stonepost-lakeside-apartments-by-black-bob-park",
      "search_query": "Stonepost Lakeside apartments by Black Bob Park",
      "category": "Park",
      "h1_title": "Stonepost Lakeside by Black Bob Park",
      "h2_subtitle": "Stonepost Lakeside Apartments offer a peaceful retreat near Black Bob Park, perfect for those seeking convenience and recreation in Olathe.",
      "page_copy": "Welcome to Stonepost Lakeside Apartment Homes, where lakeside serenity meets vibrant community living near Black Bob Park. Our community is the perfect backdrop for those who love the balance of nature and urban accessibility. With one-, two-, and three-bedroom layouts, you’ll find homes designed to suit your lifestyle, complete with in-home washers and dryers, expansive ceilings, and private outdoor spaces.\n\nOur residents enjoy premium features such as eat-in kitchens with ample pantries and the optional charm of a wood-burning fireplace. Nestled in Johnson County, we're close to major routes like 135th Street and I-35, providing you easy access to Olathe's shopping, dining, and entertainment while enjoying the outdoor activities at Black Bob Park, just moments away from your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonepost Lakeside by Black Bob Park",
      "seo_description": "Discover serene living at Stonepost Lakeside Apartments, just a stone's throw from Black Bob Park in Olathe, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "heritage-park-nearby-apartments-in-kansas",
      "search_query": "Heritage Park nearby apartments in Kansas",
      "category": "Park",
      "h1_title": "Heritage Park Nearby Apartments in Kansas",
      "h2_subtitle": "Stonepost Lakeside offers elegant living in Kansas with the advantage of being near Heritage Park. Enjoy a blend of nature and comfort.",
      "page_copy": "At Stonepost Lakeside Apartment Homes, enjoy the balance of tranquil lakeside living with the convenience of being close to Heritage Park in Kansas. Our thoughtfully designed one-, two-, and three-bedroom apartments provide a serene retreat with modern comforts, including in-home washers and dryers and generous private outdoor spaces.\n\nOur community boasts amenities like eat-in kitchens complete with pantries and charming wood-burning fireplaces, perfect for cozy evenings. Situated near major commuting routes such as 135th Street and I-35, you can easily access the vibrant lifestyle and recreational activities at Heritage Park. Experience the best of both worlds at Stonepost Lakeside, where nature and convenience meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heritage Park Nearby Apartments in Kansas",
      "seo_description": "Live at Stonepost Lakeside Apartments in Kansas, near Heritage Park, offering a perfect mix of comfort and scenic beauty for your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "cedar-lake-access-from-olathe-apartments",
      "search_query": "Cedar Lake access from Olathe apartments",
      "category": "Park",
      "h1_title": "Cedar Lake Access from Olathe Apartments",
      "h2_subtitle": "Stonepost Lakeside provides ideal access to Cedar Lake, offering picturesque living in Olathe with modern amenities and natural charm.",
      "page_copy": "Experience the best of Olathe living with convenient access to Cedar Lake at Stonepost Lakeside Apartment Homes. Our serene, lakeside community offers a relaxing environment combined with the benefits of modern living. Choose from spacious one-, two-, or three-bedroom apartments equipped with in-home washers and dryers, and enjoy the fresh air from your private outdoor space.\n\nOur amenities include beautiful eat-in kitchens with expansive pantries and the option of a cozy wood-burning fireplace, perfect for creating a welcoming home atmosphere. Situated just a short drive from Cedar Lake, our location provides easy access to both nature and the vibrant life of Olathe, with seamless connectivity via major routes like 135th Street and I-35.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Lake Access from Olathe Apartments",
      "seo_description": "Discover Stonepost Lakeside Apartments in Olathe, offering convenient access to Cedar Lake with spacious living and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "lone-elm-park-area-apartments-olathe",
      "search_query": "Lone Elm Park area apartments Olathe",
      "category": "Park",
      "h1_title": "Lone Elm Park Area Apartments in Olathe",
      "h2_subtitle": "Stonepost Lakeside provides beautiful living near Lone Elm Park, Olathe, combining nature and modern amenities for a perfect home.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Stonepost Lakeside Apartment Homes, ideally located near Lone Elm Park in Olathe. Our community offers a tranquil lakeside setting with the benefits of modern amenities, providing a perfect retreat from the hustle and bustle. Choose from our spacious one-, two-, or three-bedroom apartments, each featuring in-home washers and dryers and private outdoor spaces.\n\nResidents can enjoy the convenience of eat-in kitchens with plentiful pantries and optional wood-burning fireplaces for cozy evenings. Located within easy reach of Lone Elm Park, you'll have access to beautiful outdoor spaces while still enjoying the connectivity of being near major routes like 135th Street and I-35, placing all of Olathe's destinations within easy reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lone Elm Park Area Apartments, Olathe",
      "seo_description": "Live at Stonepost Lakeside Apartments near Lone Elm Park in Olathe, offering a perfect mix of tranquility and modern convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "frisco-lake-park-adjacent-apartments-johnson-county",
      "search_query": "Frisco Lake Park adjacent apartments in Johnson County",
      "category": "Park",
      "h1_title": "Frisco Lake Park Adjacent Apartments",
      "h2_subtitle": "Stonepost Lakeside sits beautifully adjacent to Frisco Lake Park, offering serene living in Johnson County with modern amenities.",
      "page_copy": "Located adjacent to the beautiful Frisco Lake Park, Stonepost Lakeside Apartment Homes in Johnson County offer an unparalleled living experience. Our apartments provide a harmonious blend of serene natural surroundings and contemporary comforts, making it the perfect home for those seeking a peaceful retreat.\n\nChoose from our stylish one-, two-, or three-bedroom layouts, each featuring essential amenities like in-home washers and dryers and spacious private balconies. Residents can delight in cooking in our modern eat-in kitchens with ample pantry space, or unwind by a welcoming wood-burning fireplace. With proximity to Frisco Lake Park, residents enjoy easy access to outdoor recreation while benefiting from the connectivity of nearby routes such as 135th Street and I-35.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Frisco Lake Park Adjacent Apartments",
      "seo_description": "Discover Stonepost Lakeside Apartments next to Frisco Lake Park, offering serene Johnson County living with abundant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167616",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Stonepost Lakeside offers easy access to Kansas City International Airport, providing comfortable living in Olathe with modern conveniences.",
      "page_copy": "Stonepost Lakeside Apartment Homes are strategically located in Olathe, offering an easy commute to Kansas City International Airport. This makes our community an ideal choice for frequent travelers and professionals seeking a convenient and comfortable living environment. Our apartment homes provide a serene, lakeside setting paired with modern amenities.\n\nResidents can choose from spacious one-, two-, or three-bedroom layouts, each including in-home washers and dryers and private outdoor areas. The community features inviting eat-in kitchens with abundant pantry storage, and the option of a cozy wood-burning fireplace to create a perfect ambiance. Situated with direct access to main thoroughfares like 135th Street and I-35, Stonepost Lakeside ensures you remain well-connected while enjoying the peace of lakeside living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a swimming pool and jacuzzi.",
        "public_id": "01a0b669-0c74-749c-a265-a18bc607b35b",
        "storage_key": "property/6767906449167616/01a0b669-0c74-749c-a265-a18bc607b35b.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Live at Stonepost Lakeside Apartments in Olathe, near Kansas City International Airport, offering a blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701919174"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TL3WWBKL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 5"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/7f784c5a-5328-43cf-8cf4-e2bb30643cf4/app.js?nocache=1&gaTracking=G-EC3Q3NNSRB&buttonbgcolor=c4622d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Stonepost%20Lakeside/95681"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-355-6916"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkZiZm94MTFCR0o4NzJucVhDeFJtTGc9PSIsInZhbHVlIjoiZk5tNEtwZ0VYZHY5RjJKWnArV0Uydz09IiwibWFjIjoiNjYwMWZkNDI3MzAxZmQ5MjlkYjg5ZTUyOGNkZTE3NDBlNDI2YjJlMDYxODc2MjI5NzBmMzhjYmQ3ODc4YzliMyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701919174",
  "custom_google_gtm_id": "GTM-TL3WWBKL",
  "custom_rollout_phase": "Batch 5",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/7f784c5a-5328-43cf-8cf4-e2bb30643cf4/app.js?nocache=1&gaTracking=G-EC3Q3NNSRB&buttonbgcolor=c4622d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Stonepost%20Lakeside/95681",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-355-6916",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkZiZm94MTFCR0o4NzJucVhDeFJtTGc9PSIsInZhbHVlIjoiZk5tNEtwZ0VYZHY5RjJKWnArV0Uydz09IiwibWFjIjoiNjYwMWZkNDI3MzAxZmQ5MjlkYjg5ZTUyOGNkZTE3NDBlNDI2YjJlMDYxODc2MjI5NzBmMzhjYmQ3ODc4YzliMyJ9",
  "custom_audioeye_site_id": "c423f363-45ce-453a-bade-0b2530625675",
  "custom_audioeye_site_hash": "feb98735f9ee759bd0fa87b02fa9a894"
};

export const generatedAt = '2026-11-03T22:56:55.471Z';
